<template>
  <div id="paginaScritture">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Scritture</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropStagioni"
                  ref="dropStagioni"
                  :query="queryStagioni"
                  :dataSource="stagioniData"
                  :index="stagioniIndex"
                  :fields="stagioniFields"
                  :change="onStagioneChange"
                  v-model="stagioneCorrente"
                  placeholder="Seleziona un Anno"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropSpettacoli"
                  ref="dropSpettacoli"
                  :query="querySpettacoli"
                  :dataSource="elencoSpettacoliList"
                  :index="spettacoliIndex"
                  :fields="elencoSpettacoliFields"
                  :enabled="dropSpettacoliEnabled"
                  :change="onSpettacoloChange"
                  v-model="spettacoloCorrente"
                  placeholder="Seleziona uno Spettacolo"
                  :allowFiltering="true"
                  :filtering="spettacoloFiltering"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert
                  :show="alertADismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="alertADismissCountDown = 0"
                  @dismiss-count-down="alertACountDownChanged"
                >
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-progress
                    variant="warning"
                    :max="alertADismissSecs"
                    :value="alertADismissCountDown"
                    height="4px"
                  />
                </b-alert>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <div id="GridParent">
                  <ejs-grid
                    id="gridA"
                    ref="gridA"
                    :dataSource="scrittureFullData"
                    :allowSorting="true"
                    :toolbarClick="gridAClickHandler"
                    :toolbar="gridA.toolbarOptions"
                    :height="gridA.height"
                    :allowFiltering="true"
                    :filterSettings="gridA.filterOptions"
                    :editSettings="gridA.editOptions"
                    :actionBegin="gridAactionBegin"
                    :actionComplete="gridAactionComplete"
                    :sortSettings="gridA.sortOptions"
                    :rowDataBound='rowDataBound'
                    locale='it-IT'
                  >
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="100"></e-column>
                      <!-- <e-column
                        field="spettacolo"
                        headerText="Spettacolo"
                        width="200"
                        foreignKeyField="id"
                        foreignKeyValue="titolo"
                        :dataSource="this.elencoSpettacoliList"
                      ></e-column> -->
                      <e-column
                        field="tipoCast"
                        headerText="Tipologia"
                        width="150"
                        foreignKeyField="val"
                        foreignKeyValue="label"
                        :sortComparer='sortComparer'
                        :dataSource="this.tipoCastList"
                      ></e-column>
                      <e-column
                        field="soggetto"
                        headerText="Denominazione"
                        width="200"
                        foreignKeyField="id"
                        foreignKeyValue="denominazione"
                        :dataSource="this.elencoSoggFiltratiList"
                      ></e-column>
                      <e-column
                        field="soggetto"
                        headerText="Cod. Fiscale"
                        width="200"
                        foreignKeyField="id"
                        foreignKeyValue="codiceFiscale"
                        :dataSource="this.elencoSoggFiltratiList"
                      ></e-column>
                      <e-column field="ruoloGenerale" headerText="Ruolo" width="200"></e-column>
                      <e-column
                        field="stato"
                        headerText="Stato"
                        width="150"
                        foreignKeyField="val"
                        foreignKeyValue="label"
                        :dataSource="this.scrittureStatoList"
                      ></e-column>
                      <e-column field="statoContratto" headerText="Contratto" width="150" ></e-column>
                      <e-column field="note" headerText="Note" width="500"></e-column>
                      <e-column field="inizio" headerText="Dal" :format="settings.formatoData" type="date" width="130"></e-column>
                      <e-column field="fine" headerText="Al" :format="settings.formatoData" type="date" width="130"></e-column>
                      <e-column field="numGiorniScrittura" headerText="N gg scrittura" width="130"></e-column>
                      <e-column field="compenso_totale" headerText="Compenso tot" width="150"></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
                </b-col>
                <b-col xl="4" md="4" class="pt-1">
                  <ejs-button id="downloadAnnoButton" cssClass="e-flat" @click.native="downloadXls(false)">Scarica Excel Scritture Anno</ejs-button>
                </b-col>
                <b-col xl="4" md="4" class="pt-1">
                  <ejs-button id="downloadStatsAnnoButton" cssClass="e-flat" @click.native="downloadStats()">Scarica Excel Statistiche Anno Allegato C</ejs-button>
                </b-col>
                <b-col xl="4" md="4" class="pt-1">
                  <ejs-button id="downloadAnnoCompactButton" cssClass="e-flat" @click.native="downloadXls(true)">Scarica Excel Compatto</ejs-button>
                </b-col>
                <b-col xl="4" md="4" class="pt-2">
                      <label for="filtroGrid" class="h5">Filtro righe</label>
                      <ejs-dropdownlist
                        id="filtroGrid"
                        v-model="filtroGrid"
                        :dataSource="filtroGridList"
                        :fields="filtroGridFields"
                        placeholder="Selezione Filtro Grid"
                        :change="aggiornaGrid"
                      />
                    </b-col>
                </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

    <!-- dialogA1: dialogDettaglioScrittura ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogA1"
      ref="dialogA1"
      :header="dialogA1.header"
      :buttons="dialogA1.buttons"
      :visible="dialogA1.visible"
      :showCloseIcon="dialogA1.showCloseIcon"
      :close="dialogA1Close"
      :open="dialogA1Open"
      :zIndex="dialogA1.zIndex"
      :animationSettings="dialogA1.animationSettings"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA1" v-model="dialogA1.tabAdialogA1Index">
        <b-tab title="Scrittura" @click="tabClicked('dialogA1Tab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input: Informazioni Scrittura -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Informazioni Scrittura</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo dropdown senza azioni readonly: scrittureActiveData.spettacolo  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="spettacolo" class="h5">Spettacolo</label>
                      <ejs-dropdownlist
                        id="spettacolo"
                        v-model="scrittureActiveData.spettacolo"
                        :dataSource="elencoSpettacoliList"
                        :fields="elencoSpettacoliFields"
                        placeholder="Selezione Spettacolo"
                        :readonly="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.soggetto  -->
                    <!-- ESEMPIO ATTUALE AL 30/1/23 di dropdown con ricerca e template, ben funzionante -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="soggetto" class="h5">Soggetto</label>
                      <ejs-dropdownlist
                        id="soggetto"
                        ref="soggetto"
                        v-model="scrittureActiveData.soggetto"
                        :dataSource="elencoSoggFiltratiList"
                        :fields="elencoSoggFiltratiFields"
                        :allowFiltering="true"
                        :filtering="soggettoFiltering"
                        :itemTemplate="itemTemplate"
                        :valueTemplate="valueTemplate"
                        placeholder="soggetto"
                        :change="onSoggettoChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tiposcrittura" class="h5">Tipologia Scrittura</label>
                      <ejs-dropdownlist
                        id="tiposcrittura"
                        ref="tiposcrittura"
                        v-model="scrittureActiveData.tipologia"
                        :dataSource="tipoScritturaList"
                        :fields="tipoScritturaFields"
                        placeholder="Tipologia Scrittura"
                        :change="onTipologiaScritturaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.tipoCast  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipoCast" class="h5">Tipologia Cast</label>
                      <ejs-dropdownlist
                        id="tipoCast"
                        v-model="scrittureActiveData.tipoCast"
                        :dataSource="tipoCastList"
                        :fields="labelValFields"
                        placeholder="Selezione Tipologia Cast"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.stato  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="stato" class="h5">Stato</label>
                      <ejs-dropdownlist
                        id="stato"
                        v-model="scrittureActiveData.stato"
                        :dataSource="scrittureStatoList"
                        :fields="labelValFields"
                        placeholder="Selezione Stato"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: scrittureActiveData.note  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="scrittureActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Note"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="3"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                      <label for="delayPagamento" class="h5">Scadenza Pagamento</label>
                      <ejs-dropdownlist
                        id="delayPagamento"
                        ref="delayPagamento"
                        :dataSource="delayPagamentoList"
                        :fields="delayPagamentoFields"
                        :readonly="bloccoModifica"
                        :change="onDelayPagamentoChange"
                        :value="60"
                        showClearButton="true"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataScadenzaPagamento" class="h5">Data Scadenza Pagamento</label>
                      <ejs-datepicker
                        id="dataScadenzaPagamento"
                        ref="dataScadenzaPagamento"
                        v-model="scrittureActiveData.dataScadenzaPagamento"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="pagato" class="h5">Pagato</label>
                      <ejs-dropdownlist
                        id="pagato"
                        ref="pagato"
                        v-model="scrittureActiveData.pagato"
                        :dataSource="pagatoList"
                        :fields="pagatoFields"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataPagamentoPrevista" class="h5">Data Pagamento Prevista</label>
                      <ejs-datepicker
                        id="dataPagamentoPrevista"
                        v-model="scrittureActiveData.dataPagamentoPrevista"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataPagamento" class="h5">Data Pagamento</label>
                      <ejs-datepicker
                        id="dataPagamento"
                        v-model="scrittureActiveData.dataPagamento"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="contoPagamento" class="h5">Conto Bancario</label>
                      <ejs-dropdownlist
                        id="contoPagamento"
                        ref="contoPagamento"
                        v-model="scrittureActiveData.contoPagamento"
                        :dataSource="elencoContiBancari"
                        :fields="contoBancarioFields"
                        placeholder="Seleziona il conto bancario"
                        :showClearButton="true"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="riferimentoContabile" class="h5">Riferimento Contabile</label>
                      <ejs-textbox
                        id="riferimentoContabile"
                        v-model="scrittureActiveData.riferimentoContabile"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="riferimentoContabile"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="4" md="12" class="mb-2">
                      <label for="blocco" class="h5 mr-1">Blocco modifica</label>
                      <ejs-checkbox v-if="setBloccoModifica"
                        id="blocco" name="blocco"
                        v-model="scrittureActiveData.blocco"
                        :checked="scrittureActiveData.blocco"
                      />
                      <input type="checkbox" v-model="scrittureActiveData.blocco"
                        onclick="return false" v-else />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Info varie -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Scrittura</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label for="inqualita" class="h5">Categoria INPS</label>
                      <ejs-dropdownlist
                        id="categoriaInps"
                        ref="categoriaInps"
                        v-model="scrittureActiveData.categoriaInps"
                        :dataSource="categoriaInpsList"
                        :fields="categoriaInpsFields"
                        :allowFiltering="true"
                        :filtering="categoriaInpsFiltering"
                        placeholder="Categoria Inps"
                        :index="initIndex"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label for="inqualita" class="h5">In qualita di</label>
                      <ejs-dropdownlist
                        id="inqualita"
                        ref="inqualita"
                        v-model="scrittureActiveData.in_qualita_di"
                        :dataSource="inQualitaList"
                        :fields="labelValFields"
                        :allowFiltering="true"
                        :filtering="inQualitaFiltering"
                        placeholder="In qualita di"
                        :change="onIn_qualita_diChange"
                        :index="initIndex"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="showRuolo">
                      <label for="ruolo" class="h5">Ruolo (solo per cantanti)</label>
                      <ejs-textbox
                        id="ruolo"
                        ref="ruolo"
                        v-model="scrittureActiveData.ruolo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Ruolo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="noDiritti">
                      <label class="h5">Periodo Lavorativo</label>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="noDiritti">
                      <label for="inizioIntervallo1" class="h5">Dal</label>
                      <ejs-datepicker
                        id="inizioIntervallo1"
                        ref="inizioIntervallo1"
                        v-model="scrittureActiveData.intervallo1_inizio"
                        :format="settings.formatoDatepicker"
                        placeholder="Inizio"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="noDiritti">
                      <label for="fineIntervallo1" class="h5">Al</label>
                      <ejs-datepicker
                        id="fineIntervallo1"
                        ref="fineIntervallo1"
                        v-model="scrittureActiveData.intervallo1_fine"
                        :format="settings.formatoDatepicker"
                        placeholder="Fine"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                        :change="onFineIntervalloChange"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="inizioIntervallo2" class="h5">Dal-2</label>
                      <ejs-datepicker
                        id="inizioIntervallo2"
                        v-model="scrittureActiveData.intervallo2_inizio"
                        :format="settings.formatoDatepicker"
                        placeholder="Inizio"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="fineIntervallo2" class="h5">Al-2</label>
                      <ejs-datepicker
                        id="fineIntervallo2"
                        v-model="scrittureActiveData.intervallo2_fine"
                        :format="settings.formatoDatepicker"
                        placeholder="Fine"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="inizioIntervallo3" class="h5">Dal-3</label>
                      <ejs-datepicker
                        id="inizioIntervallo3"
                        v-model="scrittureActiveData.intervallo3_inizio"
                        :format="settings.formatoDatepicker"
                        placeholder="Inizio"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="fineIntervallo3" class="h5">Al-3</label>
                      <ejs-datepicker
                        id="fineIntervallo3"
                        v-model="scrittureActiveData.intervallo3_fine"
                        :format="settings.formatoDatepicker"
                        placeholder="Fine"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showSubordinati"
                    >
                      <label for="qualifica" class="h5">Qualifica</label>
                      <ejs-dropdownlist
                        id="qualifica"
                        ref="qualifica"
                        v-model="scrittureActiveData.qualifica"
                        :dataSource="qualificaList"
                        :fields="labelValFields"
                        :allowFiltering="true"
                        :filtering="qualificaFiltering"
                        placeholder="Qualifica"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-if="soloTecniciPrestazione"
                    >
                      <label for="livello" class="h5">Livello</label>
                      <ejs-dropdownlist
                        id="livello"
                        ref="livello"
                        v-model="scrittureActiveData.livello"
                        :dataSource="livelloList2"
                        :fields="livelloFields"
                        placeholder="Livello"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-if="soloTecniciTDet">
                      <label for="livello" class="h5">Livello</label>
                      <ejs-dropdownlist
                        id="livello"
                        ref="livello"
                        v-model="scrittureActiveData.livello"
                        :dataSource="livelloList"
                        :fields="livelloFields"
                        placeholder="Livello"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="showSubordinati">
                      <label for="mansione" class="h5">Mansione</label>
                      <ejs-dropdownlist
                        id="mansione"
                        ref="mansione"
                        v-model="scrittureActiveData.mansione"
                        :dataSource="mansioneList"
                        :fields="labelValFields"
                        :allowFiltering="true"
                        :filtering="mansioneFiltering"
                        placeholder="Mansione"
                        :change="onMansioneChange"
                        :index="initIndex"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col
                      xl="12" md="12" class="mb-2"
                      v-show="soloTecniciPrestazione"
                    >
                      <label for="ore_turno_giornaliero" class="h5">
                        Ore Turno Giornaliero</label>
                      <ejs-textbox
                        id="ore_turno_giornaliero"
                        v-model="scrittureActiveData.ore_turno_giornaliero"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Ore turno"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <!-- <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="showSubordinati"
                    >
                      <label for="luogo_lavoro" class="h5"
                        >Luogo di lavoro</label
                      >
                      <ejs-textbox
                        id="sede"
                        v-model="scrittureActiveData.luogo_lavoro"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Luogo di lavoro"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col> -->
                    <b-col xl="12" md="12" class="mb-2" v-show="soloTecniciTDet" >
                      <label for="tipo_orario" class="h5">Tipologia Orario</label>
                      <ejs-dropdownlist
                        id="tipo_orario"
                        ref="tipo_orario"
                        v-model="scrittureActiveData.tipo_orario"
                        :dataSource="tipoOrarioList"
                        :fields="tipoOrarioFields"
                        placeholder="Tipologia Orario"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="soloTecniciTDet">
                      <label for="ore_settimanali" class="h5">Ore Settimanali</label>
                      <ejs-numerictextbox
                        id="ore_settimanali"
                        v-model="scrittureActiveData.ore_settimanali"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Ore Settimanali"
                        showSpinButton="false"
                        showClearButton="true"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="lun_inizio" class="h5">Inizio Lunedi</label>
                      <ejs-timepicker
                        id="lun_inizio"
                        v-model="scrittureActiveData.lun_inizio"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Inizio"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="lun_fine" class="h5">Fine Lunedi</label>
                      <ejs-timepicker
                        id="lun_fine"
                        v-model="scrittureActiveData.lun_fine"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Fine"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="mar_inizio" class="h5">Inizio Martedi</label>
                      <ejs-timepicker
                        id="mar_inizio"
                        v-model="scrittureActiveData.mar_inizio"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Inizio"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="mar_fine" class="h5">Fine Martedi</label>
                      <ejs-timepicker
                        id="mar_fine"
                        v-model="scrittureActiveData.mar_fine"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Fine"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="mer_inizio" class="h5"
                        >Inizio Mercoledi</label
                      >
                      <ejs-timepicker
                        id="mer_inizio"
                        v-model="scrittureActiveData.mer_inizio"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Inizio"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="mer_fine" class="h5">Fine Mercoledi</label>
                      <ejs-timepicker
                        id="mer_fine"
                        v-model="scrittureActiveData.mer_fine"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Fine"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="gio_inizio" class="h5">Inizio Giovedi</label>
                      <ejs-timepicker
                        id="gio_inizio"
                        v-model="scrittureActiveData.gio_inizio"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Inizio"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="gio_fine" class="h5">Fine Giovedi</label>
                      <ejs-timepicker
                        id="gio_fine"
                        v-model="scrittureActiveData.gio_fine"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Fine"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="ven_inizio" class="h5">Inizio Venerdi</label>
                      <ejs-timepicker
                        id="ven_inizio"
                        v-model="scrittureActiveData.ven_inizio"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Inizio"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="ven_fine" class="h5">Fine Venerdi</label>
                      <ejs-timepicker
                        id="ven_fine"
                        v-model="scrittureActiveData.ven_fine"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Fine"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="sab_inizio" class="h5">Inizio Sabato</label>
                      <ejs-timepicker
                        id="sab_inizio"
                        v-model="scrittureActiveData.sab_inizio"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Inizio"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="sab_fine" class="h5">Fine Sabato</label>
                      <ejs-timepicker
                        id="sab_fine"
                        v-model="scrittureActiveData.sab_fine"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Fine"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="dom_inizio" class="h5">Inizio Domenica</label>
                      <ejs-timepicker
                        id="dom_inizio"
                        v-model="scrittureActiveData.dom_inizio"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Inizio"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="soloTecniciTDet">
                      <label for="dom_fine" class="h5">Fine Domenica</label>
                      <ejs-timepicker
                        id="dom_fine"
                        v-model="scrittureActiveData.dom_fine"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                        placeholder="Fine"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="soloDiritti">
                      <label for="tipologia_diritti" class="h5">Tipologia Diritti</label>
                      <ejs-dropdownlist
                        id="tipologia_diritti"
                        ref="tipologia_diritti"
                        v-model="scrittureActiveData.tipologia_diritti"
                        :dataSource="tipologiaDirittiList"
                        :fields="labelValFields"
                        :allowFiltering="true"
                        :filtering="dirittiFiltering"
                        placeholder="Tipologia dei diritti"
                        :change="on_tipologia_diritti_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="soloDiritti">
                      <label for="causale_diritti" class="h5"
                        >I diritti d’autore..</label
                      >
                      <ejs-textbox
                        id="causale_diritti"
                        v-model="scrittureActiveData.causale_diritti"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Causale Diritti"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="soloDiritti">
                      <label for="dettagli_corrispettivo" class="h5"
                        >Dettagli corrispettivo</label>
                      <ejs-textbox
                        id="dettagli_corrispettivo"
                        v-model="scrittureActiveData.dettaglio_pagamento"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Dettaglio opzionale di pagamento"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2" v-show="showCompGiorn">
                      <label for="compenso_lordo_giornaliero" class="h5"
                        >Compenso Lordo Giornaliero</label>
                      <ejs-numerictextbox
                        id="compenso_lordo_giornaliero"
                        v-model="scrittureActiveData.compenso_lordo_giornaliero"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Compenso Lordo Giornaliero"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :change="on_compenso_lordo_giornaliero_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showCompGiorn">
                      <label for="compenso_lordo_giornaliero_scritto" class="h5">
                        Compenso lordo giornaliero in lettere</label>                      
                      <ejs-textbox
                        id="compenso_lordo_giornaliero_scritto"
                        v-model="scrittureActiveData.compenso_lordo_giornaliero_scritto"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Compenso Lordo Giornaliero Scritto"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label class="h5">Elenco Recite</label>
                    </b-col>
                    <!-- Input recita1 -->
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="recita1" class="h5">Recita-1</label>
                      <ejs-dropdownlist
                        id="recita1"
                        ref="recita1"
                        v-model="scrittureActiveData.recita1"
                        :dataSource="dettReciteList"
                        :fields="dettReciteFields"
                        placeholder="Recita"
                        showClearButton="true"
                        :change="onRecitaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomiCompRecita" >
                      <label for="importo_recita1" class="h5">Importo-1</label>
                      <ejs-numerictextbox
                        id="importo_recita1"
                        v-model="scrittureActiveData.importo_recita1"
                        format="€ ###.##"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Importo recita"
                        showSpinButton="false"
                        showClearButton="true"
                        :change="on_importo_recita_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <!-- Input recita2 -->
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="recita2" class="h5">Recita-2</label>
                      <ejs-dropdownlist
                        id="recita2"
                        ref="recita2"
                        v-model="scrittureActiveData.recita2"
                        :dataSource="dettReciteList"
                        :fields="dettReciteFields"
                        placeholder="Recita"
                        showClearButton="true"
                        :change="onRecitaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomiCompRecita" >
                      <label for="importo_recita2" class="h5">Importo-2</label>
                      <ejs-numerictextbox
                        id="importo_recita2"
                        v-model="scrittureActiveData.importo_recita2"
                        format="€ ###.##"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Importo recita"
                        showSpinButton="false"
                        showClearButton="true"
                        :change="on_importo_recita_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <!-- Input recita3 -->
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="recita3" class="h5">Recita-3</label>
                      <ejs-dropdownlist
                        id="recita3"
                        ref="recita3"
                        v-model="scrittureActiveData.recita3"
                        :dataSource="dettReciteList"
                        :fields="dettReciteFields"
                        placeholder="Recita"
                        showClearButton="true"
                        :change="onRecitaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomiCompRecita" >
                      <label for="importo_recita3" class="h5">Importo-3</label>
                      <ejs-numerictextbox
                        id="importo_recita3"
                        v-model="scrittureActiveData.importo_recita3"
                        format="€ ###.##"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Importo recita"
                        showSpinButton="false"
                        showClearButton="true"
                        :change="on_importo_recita_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="recita4" class="h5">Recita-4</label>
                      <ejs-dropdownlist
                        id="recita4"
                        ref="recita4"
                        v-model="scrittureActiveData.recita4"
                        :dataSource="dettReciteList"
                        :fields="dettReciteFields"
                        placeholder="Recita"
                        showClearButton="true"
                        :change="onRecitaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomiCompRecita" >
                      <label for="importo_recita4" class="h5">Importo-4</label>
                      <ejs-numerictextbox
                        id="importo_recita4"
                        v-model="scrittureActiveData.importo_recita4"
                        format="€ ###.##"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Importo recita"
                        showSpinButton="false"
                        showClearButton="true"
                        :change="on_importo_recita_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomi">
                      <label for="recita5" class="h5">Recita-5</label>
                      <ejs-dropdownlist
                        id="recita5"
                        ref="recita5"
                        v-model="scrittureActiveData.recita5"
                        :dataSource="dettReciteList"
                        :fields="dettReciteFields"
                        placeholder="Recita"
                        showClearButton="true"
                        :change="onRecitaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2" v-show="showAutonomiCompRecita" >
                      <label for="importo_recita5" class="h5">Importo-5</label>
                      <ejs-numerictextbox
                        id="importo_recita5"
                        v-model="scrittureActiveData.importo_recita5"
                        format="€ ###.##"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Importo recita"
                        showSpinButton="false"
                        showClearButton="true"
                        :change="on_importo_recita_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="showCompCompl">
                      <label for="compenso_lordo_complessivo" class="h5">Compenso Lordo Complessivo</label>
                      <ejs-numerictextbox
                        id="compenso_lordo_complessivo"
                        v-model="scrittureActiveData.compenso_lordo_complessivo"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Compenso Lordo Complessivo"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :change="on_compenso_lordo_complessivo_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="showCompCompl">
                      <label for="compenso_lordo_complessivo_scritto" class="h5">
                        Compenso lordo complessivo in lettere</label>
                      <ejs-textbox
                        id="compenso_lordo_complessivo_scritto"
                        v-model="scrittureActiveData.compenso_lordo_complessivo_scritto"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Compenso Lordo Complessivo Scritto"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="soloDiritti">
                      <label for="durata_anni_diritti" class="h5">
                        Durata Anni Diritti (opzionale)</label>
                      <ejs-numerictextbox
                        id="durata_anni_diritti"
                        v-model="scrittureActiveData.durata_anni_diritti"
                        floatLabelType="Never"
                        cssClass=""
                        showSpinButton="false"
                        showClearButton="true"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo numero: scrittureActiveData.numGiorniScrittura -->
                    <b-col xl="12" md="12" class="mb-2" v-show="showDettDate">
                      <label for="numGiorniScrittura" class="h5">
                        Numero Giorni di Scrittura</label>
                      <ejs-numerictextbox
                        id="numGiorniScrittura"
                        v-model="scrittureActiveData.numGiorniScrittura"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero giorni di scrittura"
                        showSpinButton="false"
                        showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :change="onnumGiorniScritturaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo numero: scrittureActiveData.numGiorniCoproduzione -->
                    <b-col xl="12" md="12" class="mb-2" v-show="showNumGiorniCoproduzione">
                      <label for="numGiorniCoproduzione" class="h5">
                        Numero Giorni per Coproduzione</label>
                      <ejs-numerictextbox
                        id="numGiorniCoproduzione"
                        v-model="scrittureActiveData.numGiorniCoproduzione"
                        floatLabelType="Never" cssClass=""
                        format="###"
                        placeholder="Numero giorni per Coproduzione"
                        showSpinButton="false" showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="showNumGiorniCoproduzione">
                      <label for="numGiorniPressoCoproduttore" class="h5">
                        Numero Giorni presso Coproduttore</label>
                      <ejs-numerictextbox
                        id="numGiorniCoproduzione"
                        v-model="scrittureActiveData.numGiorniPressoCoproduttore"
                        floatLabelType="Never" cssClass=""
                        format="###"
                        placeholder="Numero giorni presso Coproduttore"
                        showSpinButton="false" showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <!-- Input di tipo numero: scrittureActiveData.numGiorniRecite -->
                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label for="numGiorniRecite" class="h5">
                        Numero Giorni di Recite</label>
                      <ejs-numerictextbox
                        id="numGiorniRecite"
                        v-model="scrittureActiveData.numGiorniRecite"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero giorni di recite"
                        showSpinButton="false"
                        showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :readonly="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label for="ulteriori_precisazioni" class="h5"
                        >Ulteriori precisazioni</label>
                      <ejs-textbox
                        id="ulteriori_precisazioni"
                        v-model="scrittureActiveData.ulteriori_precisazioni"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Ulteriori precisazioni opzionali"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label for="dettaglio_pagamento" class="h5">
                        Dettaglio pagamento</label>
                      <ejs-textbox
                        id="dettaglio_pagamento"
                        v-model="scrittureActiveData.dettaglio_pagamento"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Dettaglio pagamento opzionale"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <!-- Input di tipo checkbox: scrittureActiveData.usaAllegato1 -->
                    <b-col xl="6" md="12" class="mb-2 align-items-center" v-show="showSubordinati">
                      <b-row class="m-0">
                        <label for="usaAllegato1" class="h5 mr-1">
                          Genera Allegato 1</label>
                        <ejs-checkbox
                          id="usaAllegato1"
                          v-model="scrittureActiveData.usaAllegato1"
                          :checked="scrittureActiveData.usaAllegato1"
                          name="usaAllegato1"
                          :readonly="bloccoModifica"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.tipoCompAll1  -->
                    <b-col
                      xl="12" md="12" class="mb-2"
                      v-show="scrittureActiveData.usaAllegato1">
                      <label for="tipoCompAll1" class="h5">Tipo Compenso</label>
                      <ejs-dropdownlist
                        id="tipoCompAll1"
                        v-model="scrittureActiveData.tipoCompAll1"
                        :dataSource="scrittureTipoCompAll1List"
                        :fields="labelValFields"
                        placeholder="Selezione tipo compenso"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo valuta: scrittureActiveData.all1_compenso_giornaliero -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="scrittureActiveData.usaAllegato1"
                    >
                      <label for="all1_compenso_giornaliero" class="h5">
                        Compenso Giornaliero</label>
                      <ejs-numerictextbox
                        id="all1_compenso_giornaliero"
                        v-model="scrittureActiveData.all1_compenso_giornaliero"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Compenso Giornaliero"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo numero: scrittureActiveData.all1_numGiorniMax -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="scrittureActiveData.usaAllegato1"
                    >
                      <label for="all1_numGiorniMax" class="h5">
                        Numero Giorni Massimi</label>
                      <ejs-numerictextbox
                        id="all1_numGiorniMax"
                        v-model="scrittureActiveData.all1_numGiorniMax"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero giorni di scrittura"
                        showSpinButton="false"
                        showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label for="compensoTotale" class="h5">
                        Compenso Totale</label>
                      <ejs-numerictextbox
                        id="compensoTotale"
                        v-model="scrittureActiveData.compenso_totale"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Compenso Totale"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :readonly="true"
                      />
                    </b-col>

                    
                    <b-col xl="12" md="12" class="mb-2" v-show="showRegimeFiscale">
                      <label for="regimeFiscale" class="h5">Regime Fiscale</label>
                      <ejs-dropdownlist
                        id="regimeFiscale"
                        ref="regimeFiscale"
                        v-model="scrittureActiveData.regimeFiscale"
                        :dataSource="regimeFiscaleList"
                        :fields="labelValFields"
                        placeholder="Regime Fiscale"
                        :readonly="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="showRegimeFiscale">
                      <label for="esenzione" class="h5">Esenzione</label>
                      <ejs-dropdownlist
                        id="esenzione"
                        ref="esenzione"
                        v-model="scrittureActiveData.esenzione"
                        :dataSource="esenzioneList"
                        :fields="labelValFields"
                        placeholder="Esenzione"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="false">
                      <label for="tipologiaContributoSoggetto" class="h5">
                        Tipologia Contributo Soggetto</label>
                      <ejs-dropdownlist
                        id="tipologiaContributoSoggetto"
                        v-model="scrittureActiveData.tipologia_contributo_soggetto"
                        :dataSource="tipologiaContributoList"
                        :fields="labelValFields"
                        placeholder="Selezione tipologia contributo"
                        :change="on_tipologia_contributo_soggetto_change"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="false">
                      <label for="contributi_carico_ditta" class="h5">Contributi Carico Ditta</label>
                      <ejs-numerictextbox
                        id="contributi_carico_ditta"
                        v-model="scrittureActiveData.contributi_carico_ditta"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Contributi Carico Ditta"
                        showSpinButton="false"
                        showClearButton="true"
                        :readonly="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="false">
                      <label for="contributi_carico_dipendente" class="h5">Contributi Carico Dipendente</label>
                      <ejs-numerictextbox
                        id="contributi_carico_dipendente"
                        v-model="scrittureActiveData.contributi_carico_dipendente"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Contributi Carico Dipendente"
                        showSpinButton="false"
                        showClearButton="true"
                        :readonly="true"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2" v-show="false">
                      <label for="costoAziendaTotale" class="h5">Costo Azienda Totale</label>
                      <ejs-numerictextbox
                        id="costoAziendaTotale"
                        v-model="scrittureActiveData.costo_azienda_totale"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Costo Azienda Totale"
                        showSpinButton="false"
                        showClearButton="true"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2 align-items-center" v-show="false">
                      <b-row class="m-0">
                        <label for="costoRetribuzionePreventivo" class="h5 mr-1">Costo retribuzione preventivo</label>
                      </b-row>
                      <ejs-numerictextbox
                        id="costoRetribuzionePreventivo"
                        v-model="oneriPreventivoActiveData.costo_retribuzione"
                        floatLabelType="Never" cssClass=""
                        placeholder="" showSpinButton="false" showClearButton="true"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2 align-items-center" v-show="false">
                      <b-row class="m-0">
                        <label for="costoContributivoPreventivo" class="h5 mr-1">Costo contributivo preventivo</label>
                      </b-row>
                      <ejs-numerictextbox
                        id="costoContributivoPreventivo"
                        v-model="oneriPreventivoActiveData.costo_contributivo"
                        floatLabelType="Never" cssClass=""
                        placeholder="" showSpinButton="false" showClearButton="true"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2 align-items-center" v-show="false">
                      <b-row class="m-0">
                        <label for="costoINAILPreventivo" class="h5 mr-1">Costo INAIL preventivo</label>
                      </b-row>
                      <ejs-numerictextbox
                        id="costoINAILPreventivo"
                        v-model="oneriPreventivoActiveData.costo_inail"
                        floatLabelType="Never" cssClass=""
                        placeholder="" showSpinButton="false" showClearButton="true"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2 align-items-center" v-show="false">
                      <b-row class="m-0">
                        <label for="oneriCaricoDittaPreventivo" class="h5 mr-1">Oneri carico ditta preventivo</label>
                      </b-row>
                      <ejs-numerictextbox
                        id="oneriCaricoDittaPreventivo"
                        v-model="oneriPreventivoActiveData.oneri_carico_ditta"
                        floatLabelType="Never" cssClass=""
                        placeholder="" showSpinButton="false" showClearButton="true"
                        :readonly="true"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="showCostoAzGiorn">
                      <label for="costo_azienda_giornaliero" class="h5">Costo Azienda Giornaliero</label>
                      <ejs-numerictextbox
                        id="costo_azienda_giornaliero"
                        v-model="scrittureActiveData.costo_azienda_giornaliero"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Costo Azienda Giornaliero"
                        showSpinButton="false"
                        showClearButton="true"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo valuta: scrittureActiveData.retribGiornaliera -->
                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label for="retribGiornaliera" class="h5">Retribuzione Giornaliera</label>
                      <ejs-numerictextbox
                        id="retribGiornaliera"
                        v-model="scrittureActiveData.retribGiornaliera"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Retribuzione Giornaliera"
                        showSpinButton="false"
                        showClearButton="true"
                        :readonly="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.testRetribGiornaliera  -->
                    <b-col xl="12" md="12" class="mb-2" v-show="showAutonomi">
                      <label for="testRetribGiornaliera" class="h5">Test Retribuzione Giornaliera</label>
                      <ejs-textbox
                        id="testRetribGiornaliera"
                        v-model="scrittureActiveData.testRetribGiornaliera"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Test Retribuzione Giornaliera"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: scrittureActiveData.numeroElementi -->
                    <b-col xl="12" md="12" class="mb-2" v-show="showNumeroElementi">
                      <label for="numElementi" class="h5">Numero di Elementi</label>
                      <ejs-numerictextbox
                        id="numeroElementi"
                        v-model="scrittureActiveData.numeroElementi"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero di elementi"
                        showSpinButton="false"
                        showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <!-- Input di tipo numero: scrittureActiveData.giorniDiaria -->
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="giorniDiaria" class="h5" >Numero Pasti Diaria</label>
                      <ejs-numerictextbox
                        id="giorniDiaria"
                        v-model="scrittureActiveData.giorniDiaria"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Giorni di Diaria"
                        showSpinButton="false"
                        showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :change="onDiariaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="importoSingolaDiaria" class="h5">Importo Singola Diaria</label>
                      <ejs-numerictextbox
                        id="importoSingolaDiaria"
                        v-model="scrittureActiveData.importoSingolaDiaria"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Importo Singola Diaria"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :change="onDiariaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="numeroPernotti" class="h5" >Numero Pernotti</label>
                      <ejs-numerictextbox
                        id="numeroPernotti"
                        v-model="scrittureActiveData.numeroPernotti"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Pernotti"
                        showSpinButton="false"
                        showClearButton="true"
                        :step="settings.stepDayInteger"
                        :min="settings.minDayInteger"
                        :max="settings.maxDayInteger"
                        :change="onDiariaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="importoSingoloPernotto" class="h5">Importo Singolo Pernotto</label>
                      <ejs-numerictextbox
                        id="importoSingoloPernotto"
                        v-model="scrittureActiveData.importoSingoloPernotto"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Importo Singola Diaria"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :change="onDiariaChange"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="importoTotaleDiaria" class="h5">Importo Totale Diaria e Pernotti</label>
                      <ejs-numerictextbox
                        id="importoTotaleDiaria"
                        v-model="scrittureActiveData.importoTotaleDiaria"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Importo Totale Diaria e Pernotti"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        readonly="true"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="contributiDiaria" class="h5">Contributi Diaria</label>
                      <ejs-numerictextbox
                        id="contributiDiaria"
                        v-model="scrittureActiveData.contributiDiaria"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Contributi Diaria"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        readonly="true"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="rimborsoKmTotale" class="h5"
                        >Rimborso Km Totale</label>
                      <ejs-numerictextbox
                        id="rimborsoKmTotale"
                        v-model="scrittureActiveData.rimborsoKmTotale"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Rimborso Km Totale"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :change="aggiornaTotaleDiariaRimborsi"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="speseAlloggio" class="h5"
                        >Spese Alloggio</label>
                      <ejs-numerictextbox
                        id="speseAlloggio"
                        v-model="scrittureActiveData.speseAlloggio"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Spese Alloggio"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :change="aggiornaTotaleDiariaRimborsi"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="rimborsoSpese" class="h5"
                        >Rimborso Spese</label>
                      <ejs-numerictextbox
                        id="rimborsoSpese"
                        v-model="scrittureActiveData.rimborsoSpese"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Rimborso Spese"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :change="aggiornaTotaleDiariaRimborsi"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="6" md="12" class="mb-2">
                      <label for="talatoPaypal" class="h5"
                        >Pagamenti Paypal</label>
                      <ejs-numerictextbox
                        id="talatoPaypal"
                        v-model="scrittureActiveData.talatoPaypal"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Pagamenti Paypal"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        :change="aggiornaTotaleDiariaRimborsi"
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="totaleDiariaRimborsi" class="h5">
                        Totale Diaria Rimborsi</label>
                      <ejs-numerictextbox
                        id="totaleDiariaRimborsi"
                        v-model="scrittureActiveData.totaleDiariaRimborsi"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Totale Diaria Rimborsi"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                        readonly="true"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="6" md="6" class="mb-2" v-show="showCompagnieOspiti">
                      <label for="nome_obbligo" class="h5">Nome d'obbligo</label>
                      <ejs-textbox
                        id="nome_obbligo"
                        v-model="scrittureActiveData.nome_obbligo"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="3" md="3" class="mb-2" v-show="showCompagnieOspiti">
                      <label for="numero_omaggi" class="h5">Numero omaggi</label>
                      <ejs-textbox
                        id="numero_omaggi"
                        v-model="scrittureActiveData.numero_omaggi"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2" v-show="showCompagnieOspiti">
                      <label for="fornitura_teatro" class="h5">Fornitura Teatro</label>
                      <ejs-textbox
                        id="fornitura_teatro"
                        v-model="scrittureActiveData.fornitura_teatro"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="bloccoModifica"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Date Scrittura -->
            <b-col xl="6" md="12" v-show="showDettDate">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettagli Date Scrittura</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo calendar multidate: scrittureActiveData.dettGiorniScrittura  -->
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="dettGiorniScrittura" class="h5">
                        Dettaglio Giorni di Scrittura</label>
                      <ejs-calendar
                        :isMultiSelection="true"
                        id="dettGiorniScrittura"
                        ref="dettGiorniScrittura"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        :change="giorniScritturaChange"
                        locale='en-US'
                      ></ejs-calendar>
                    </b-col>

                    <!-- Input di tipo calendar multidate: scrittureActiveData.dettGiorniPermesso  -->
                    <b-col xl="6" md="12" class="mb-2">
                      <label for="dettGiorniPermesso" class="h5">
                        Dettaglio Giorni di Permesso</label>
                      <ejs-calendar
                        :isMultiSelection="true"
                        id="dettGiorniPermesso"
                        ref="dettGiorniPermesso"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        :change="giorniPermessoChange"
                        locale='en-US'
                      ></ejs-calendar>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: specifiche contratto ------------------------------- -->
            <b-col xl="6" md="12" v-show="showCardContratto">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Contratto</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <b-row>
                    <!-- Input di tipo data: scrittureActiveData.dataContratto -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dataContratto" class="h5"
                        >Data del Contratto</label
                      >
                      <ejs-datepicker
                        id="dataContratto"
                        v-model="scrittureActiveData.dataContratto"
                        :format="settings.formatoDatepicker"
                        placeholder="Data Contratto"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        :change="on_dataContratto_change"
                        locale='en-US'
                        :readonly="bloccoModifica"
                      />
                    </b-col>

                    <b-col
                      xl="12"
                      md="12"
                      class="text-right mt-1"
                      v-show="showGeneraBozzaContratto"
                    >
                      <ejs-button
                        id="generaContrattoButton"
                        cssClass="e-flat"
                        @click.native="generaContrattoClick()"
                        >Genera Contratto</ejs-button
                      >
                    </b-col>
                    <!-- da fixare -->
                    <b-col
                      xl="12"
                      md="12"
                      class="text-right mt-1"
                      v-show="showDownloadBozzaContratto"
                    >
                      <ejs-button
                        id="downloadBozzaContrattoButton"
                        cssClass="e-flat"
                        @click.native="downloadBozzaContrattoClick()"
                        >Scarica il Contratto</ejs-button
                      >
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab
          title="Personale Ministero Preventivo"
          v-if="this.scrittureActiveId && this.spettacoloCorrenteHasMinistero && nonMostrare"
          @click="tabClicked('dialogA1Tab02')"
        >
          <b-row class="match-height">
            <b-col xl="12" md="12" class="text-right mt-1">
                      <ejs-button id="calcolaPersonaleMinisteroPrevButton" cssClass="e-flat"
                        @click.native="calcolaPersonaleMinisteroPrev()">RECUPERA DATI PREVENTIVO</ejs-button>
                    </b-col>
            <!-- Card con Elementi Input: Dettaglio Ministero Preventivo 1 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ministero Preventivo 1</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo checkbox: scrittureActiveData.persMinPrevPersonaleDiTerzi -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="persMinPrevPersonaleDiTerzi" class="h5 mr-1">
                          Personale di Terzi</label>
                        <ejs-checkbox
                          id="persMinPrevPersonaleDiTerzi"
                          v-model="scrittureActiveData.persMinPrevPersonaleDiTerzi"
                          ref="persMinPrevPersonaleDiTerzi"
                          :checked="scrittureActiveData.persMinPrevPersonaleDiTerzi"
                          name="persMinPrevPersonaleDiTerzi"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinPrevDenominazione  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="this.scrittureActiveData.persMinPrevPersonaleDiTerzi"
                    >
                      <label for="persMinPrevDenominazione" class="h5">Denominazione</label>
                      <ejs-textbox
                        id="persMinPrevDenominazione"
                        v-model="scrittureActiveData.persMinPrevDenominazione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Denominazione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: scrittureActiveData.persMinPrevPersonaleStraniero -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2 align-items-center"
                      v-show="!this.scrittureActiveData.persMinPrevPersonaleDiTerzi"
                    >
                      <b-row class="m-0">
                        <label
                          for="persMinPrevPersonaleStraniero"
                          class="h5 mr-1"
                          >Personale Straniero</label>
                        <ejs-checkbox
                          id="persMinPrevPersonaleStraniero"
                          v-model="scrittureActiveData.persMinPrevPersonaleStraniero"
                          ref="persMinPrevPersonaleStraniero"
                          :checked="scrittureActiveData.persMinPrevPersonaleStraniero"
                          name="persMinPrevPersonaleStraniero"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinPrevCodiceFiscale  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevCodiceFiscale" class="h5"
                        >Codice Fiscale</label
                      >
                      <ejs-textbox
                        id="persMinPrevCodiceFiscale"
                        v-model="scrittureActiveData.persMinPrevCodiceFiscale"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Codice Fiscale"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinPrevPartitaIva  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="this.scrittureActiveData.persMinPrevPersonaleDiTerzi"
                    >
                      <label for="persMinPrevPartitaIva" class="h5"
                        >Partita Iva</label
                      >
                      <ejs-textbox
                        id="persMinPrevPartitaIva"
                        v-model="scrittureActiveData.persMinPrevPartitaIva"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita Iva"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="!this.scrittureActiveData.persMinPrevPersonaleDiTerzi"
                    >
                      <label for="persMinPrevNome" class="h5">Nome</label>
                      <ejs-textbox
                        id="persMinPrevNome"
                        v-model="scrittureActiveData.persMinPrevNome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinPrevCognome  -->
                    <b-col
                      xl="12" md="12" class="mb-2"
                      v-show="!this.scrittureActiveData.persMinPrevPersonaleDiTerzi"
                    >
                      <label for="persMinPrevCognome" class="h5">Cognome</label>
                      <ejs-textbox
                        id="persMinPrevCognome"
                        v-model="scrittureActiveData.persMinPrevCognome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Cognome"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo data: scrittureActiveData.persMinPrevDataNascita -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="!this.scrittureActiveData.persMinPrevPersonaleDiTerzi"
                    >
                      <label for="persMinPrevDataNascita" class="h5"
                        >Data di Nascita</label
                      >
                      <ejs-datepicker
                        id="persMinPrevDataNascita"
                        v-model="scrittureActiveData.persMinPrevDataNascita"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        placeholder="Data di Nascita"
                        locale='en-US'
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.persMinPrevNazionalita  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevNazionalita" class="h5"
                        >Nazionalità</label
                      >
                      <ejs-dropdownlist
                        id="persMinPrevNazionalita"
                        ref="persMinPrevNazionalita"
                        v-model="scrittureActiveData.persMinPrevNazionalita"
                        :dataSource="personaleMinisteroNazionalitaList"
                        :fields="personaleMinisteroNazionalitaFields"
                        placeholder="Nazionalità"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: scrittureActiveData.persMinPrevUnder35 -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2 align-items-center"
                      v-show="this.scrittureActiveData.persMinPrevPersonaleDiTerzi"
                    >
                      <b-row class="m-0">
                        <label for="persMinPrevUnder35" class="h5 mr-1"
                          >Under 35</label
                        >
                        <ejs-checkbox
                          id="persMinPrevUnder35"
                          v-model="scrittureActiveData.persMinPrevUnder35"
                          ref="persMinPrevUnder35"
                          :checked="scrittureActiveData.persMinPrevUnder35"
                          name="persMinPrevUnder35"
                        />
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Dettaglio Ministero Preventivo 2 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ministero Preventivo 2</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.persMinPrevCodiceINPS  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="!this.scrittureActiveData.persMinPrevPersonaleDiTerzi"
                    >
                      <label for="persMinPrevCodiceINPS" class="h5"
                        >Categoria INPS</label
                      >
                      <ejs-dropdownlist
                        id="persMinPrevCodiceINPS"
                        ref="persMinPrevCodiceINPS"
                        v-model="scrittureActiveData.persMinPrevCodiceINPS"
                        :dataSource="categoriaInpsList"
                        :fields="categoriaInpsFields"
                        :allowFiltering="true"
                        :filtering="categoriaInpsFiltering"
                        placeholder="Categoria INPS"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.persMinPrevTipoPersonale  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevTipoPersonale" class="h5"
                        >Tipologia Personale</label
                      >
                      <ejs-dropdownlist
                        id="persMinPrevTipoPersonale"
                        ref="persMinPrevTipoPersonale"
                        v-model="scrittureActiveData.persMinPrevTipoPersonale"
                        :dataSource="personaleMinisteroTipoPersonaleList"
                        :fields="personaleMinisteroTipoPersonaleFields"
                        placeholder="Tipologia Personale"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.persMinPrevTipoRapporto  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevTipoRapporto" class="h5"
                        >Tipologia Rapporto</label
                      >
                      <ejs-dropdownlist
                        id="persMinPrevTipoRapporto"
                        ref="persMinPrevTipoRapporto"
                        v-model="scrittureActiveData.persMinPrevTipoRapporto"
                        :dataSource="personaleMinisteroTipoRapportoList"
                        :fields="personaleMinisteroTipoRapportoFields"
                        placeholder="Tipologia Rapporto"
                      />
                    </b-col>

                    <!-- Input di tipo data: scrittureActiveData.persMinPrevDataInizio -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevDataInizio" class="h5"
                        >Data Inizio</label
                      >
                      <ejs-datepicker
                        id="persMinPrevDataInizio"
                        ref="persMinPrevDataInizio"
                        v-model="scrittureActiveData.persMinPrevDataInizio"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        placeholder="Data di Inizio"
                        locale='en-US'
                      />
                    </b-col>

                    <!-- Input di tipo data: scrittureActiveData.persMinPrevDataFine -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevDataFine" class="h5"
                        >Data Fine</label
                      >
                      <ejs-datepicker
                        id="persMinPrevDataFine"
                        ref="persMinPrevDataFine"
                        v-model="scrittureActiveData.persMinPrevDataFine"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        placeholder="Data di Fine"
                        locale='en-US'
                      />
                    </b-col>

                    <!-- Input di tipo numero: scrittureActiveData.persMinPrevGiornateLavorative -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevGiornateLavorative" class="h5"
                        >Giornate Lavorative</label
                      >
                      <ejs-numerictextbox
                        id="persMinPrevGiornateLavorative"
                        ref="persMinPrevGiornateLavorative"
                        v-model="scrittureActiveData.persMinPrevGiornateLavorative"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Giornate Lavorative"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo valuta: scrittureActiveData.persMinPrevOneri -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevOneri" class="h5">Oneri</label>
                      <ejs-numerictextbox
                        id="persMinPrevOneri"
                        ref="persMinPrevOneri"
                        v-model="scrittureActiveData.persMinPrevOneri"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Oneri"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: scrittureActiveData.persMinPrevRetribuzione -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="persMinPrevRetribuzione" class="h5 mr-1"
                          >Retribuzione</label
                        >
                        <ejs-checkbox
                          id="persMinPrevRetribuzione"
                          v-model="scrittureActiveData.persMinPrevRetribuzione"
                          ref="persMinPrevRetribuzione"
                          :checked="scrittureActiveData.persMinPrevRetribuzione"
                          name="persMinPrevRetribuzione"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinPrevRuolo  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="
                        !this.scrittureActiveData.persMinPrevPersonaleDiTerzi
                      "
                    >
                      <label for="persMinPrevRuolo" class="h5">Ruolo</label>
                      <ejs-textbox
                        id="persMinPrevRuolo"
                        ref="persMinPrevRuolo"
                        v-model="scrittureActiveData.persMinPrevRuolo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Ruolo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Dettaglio Ministero Preventivo Oneri -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ministero Preventivo Oneri</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinPrevCostoRetribuzione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevCostoRetribuzione " class="h5">Costo Retribuzione</label>
                      <ejs-numerictextbox
                        id="persMinPrevCostoRetribuzione"
                        ref="persMinPrevCostoRetribuzione"
                        v-model="scrittureActiveData.persMinPrevCostoRetribuzione"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Costo Retribuzione"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinPrevCostoContributivo -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevCostoContributivo" class="h5">Costo Contributivo</label>
                      <ejs-numerictextbox
                        id="persMinPrevCostoContributivo"
                        ref="persMinPrevCostoContributivo"
                        v-model="scrittureActiveData.persMinPrevCostoContributivo"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Costo Contributivo"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinPrevCostoInail -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevCostoInail" class="h5">Costo Inail</label>
                      <ejs-numerictextbox
                        id="persMinPrevCostoInail"
                        ref="persMinPrevCostoInail"
                        v-model="scrittureActiveData.persMinPrevCostoInail"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Costo Inail"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinPrevOneri -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevOneri" class="h5">Oneri</label>
                      <ejs-numerictextbox
                        id="persMinPrevOneri"
                        ref="persMinPrevOneri"
                        v-model="scrittureActiveData.persMinPrevOneri"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Oneri"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinPrevRivalsa -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevRivalsa" class="h5">Rivalsa</label>
                      <ejs-numerictextbox
                        id="persMinPrevRivalsa"
                        ref="persMinPrevRivalsa"
                        v-model="scrittureActiveData.persMinPrevRivalsa"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Rivalsa"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinPrevOneriTotali -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevOneriTotali" class="h5">Oneri Totali</label>
                      <ejs-numerictextbox
                        id="persMinPrevOneriTotali"
                        ref="persMinPrevOneriTotali"
                        v-model="scrittureActiveData.persMinPrevOneriTotali"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Oneri Totali"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

          </b-row>
        </b-tab>

        <b-tab
          title="Personale Ministero Consuntivo"
          v-if="this.scrittureActiveId && this.spettacoloCorrenteHasMinistero && nonMostrare"
          @click="tabClicked('dialogA1Tab03')"
        >
          <b-row class="match-height">
            <b-col xl="12" md="12" class="text-right mt-1">
                      <ejs-button id="calcolaPersonaleMinisteroConsButton" cssClass="e-flat"
                        @click.native="calcolaPersonaleMinisteroCons()">RECUPERA DATI CONSUNTIVO</ejs-button>
                    </b-col>
            <!-- Card con Elementi Input: Dettaglio Ministero Consuntivo 1 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ministero Consuntivo 1</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo checkbox: scrittureActiveData.persMinConsPersonaleDiTerzi -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="persMinConsPersonaleDiTerzi" class="h5 mr-1"
                          >Personale di Terzi</label
                        >
                        <ejs-checkbox
                          id="persMinConsPersonaleDiTerzi"
                          v-model="
                            scrittureActiveData.persMinConsPersonaleDiTerzi
                          "
                          ref="persMinConsPersonaleDiTerzi"
                          :checked="
                            scrittureActiveData.persMinConsPersonaleDiTerzi
                          "
                          name="persMinConsPersonaleDiTerzi"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinConsDenominazione  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="
                        this.scrittureActiveData.persMinConsPersonaleDiTerzi
                      "
                    >
                      <label for="persMinConsDenominazione" class="h5"
                        >Denominazione</label
                      >
                      <ejs-textbox
                        id="persMinConsDenominazione"
                        v-model="scrittureActiveData.persMinConsDenominazione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Denominazione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: scrittureActiveData.persMinConsPersonaleStraniero -->
                    <b-col xl="12" md="12"
                      class="mb-2 align-items-center"
                      v-show="!this.scrittureActiveData.persMinConsPersonaleDiTerzi">
                      <b-row class="m-0">
                        <label for="persMinConsPersonaleStraniero"
                          class="h5 mr-1">Personale Straniero</label>
                        <ejs-checkbox
                          id="persMinConsPersonaleStraniero"
                          v-model="scrittureActiveData.persMinConsPersonaleStraniero"
                          ref="persMinConsPersonaleStraniero"
                          :checked="scrittureActiveData.persMinConsPersonaleStraniero"
                          name="persMinConsPersonaleStraniero"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinConsCodiceFiscale  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsCodiceFiscale" class="h5">
                        Codice Fiscale</label>
                      <ejs-textbox
                        id="persMinConsCodiceFiscale"
                        v-model="scrittureActiveData.persMinConsCodiceFiscale"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Codice Fiscale"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinConsPartitaIva  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="
                        this.scrittureActiveData.persMinConsPersonaleDiTerzi
                      "
                    >
                      <label for="persMinConsPartitaIva" class="h5"
                        >Partita Iva</label
                      >
                      <ejs-textbox
                        id="persMinConsPartitaIva"
                        v-model="scrittureActiveData.persMinConsPartitaIva"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita Iva"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinConsNome  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="
                        !this.scrittureActiveData.persMinConsPersonaleDiTerzi
                      "
                    >
                      <label for="persMinConsNome" class="h5">Nome</label>
                      <ejs-textbox
                        id="persMinConsNome"
                        v-model="scrittureActiveData.persMinConsNome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinConsCognome  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="
                        !this.scrittureActiveData.persMinConsPersonaleDiTerzi
                      "
                    >
                      <label for="persMinConsCognome" class="h5">Cognome</label>
                      <ejs-textbox
                        id="persMinConsCognome"
                        v-model="scrittureActiveData.persMinConsCognome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Cognome"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo data: scrittureActiveData.persMinConsDataNascita -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="
                        !this.scrittureActiveData.persMinConsPersonaleDiTerzi
                      "
                    >
                      <label for="persMinConsDataNascita" class="h5"
                        >Data di Nascita</label
                      >
                      <ejs-datepicker
                        id="persMinConsDataNascita"
                        v-model="scrittureActiveData.persMinConsDataNascita"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        placeholder="Data di Nascita"
                        locale='en-US'
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.persMinConsNazionalita  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsNazionalita" class="h5"
                        >Nazionalità</label
                      >
                      <ejs-dropdownlist
                        id="persMinConsNazionalita"
                        ref="persMinConsNazionalita"
                        v-model="scrittureActiveData.persMinConsNazionalita"
                        :dataSource="personaleMinisteroNazionalitaList"
                        :fields="personaleMinisteroNazionalitaFields"
                        placeholder="Nazionalità"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: scrittureActiveData.persMinConsUnder35 -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2 align-items-center"
                      v-show="
                        this.scrittureActiveData.persMinConsPersonaleDiTerzi
                      "
                    >
                      <b-row class="m-0">
                        <label for="persMinConsUnder35" class="h5 mr-1"
                          >Under 35</label
                        >
                        <ejs-checkbox
                          id="persMinConsUnder35"
                          v-model="scrittureActiveData.persMinConsUnder35"
                          ref="persMinConsUnder35"
                          :checked="scrittureActiveData.persMinConsUnder35"
                          name="persMinConsUnder35"
                        />
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Dettaglio Ministero Consuntivo 2 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ministero Consuntivo 2</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.persMinConsCodiceINPS  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="
                        !this.scrittureActiveData.persMinConsPersonaleDiTerzi
                      "
                    >
                      <label for="persMinConsCodiceINPS" class="h5"
                        >Categoria INPS</label
                      >
                      <ejs-dropdownlist
                        id="persMinConsCodiceINPS"
                        ref="persMinConsCodiceINPS"
                        v-model="scrittureActiveData.persMinConsCodiceINPS"
                        :dataSource="categoriaInpsList"
                        :fields="categoriaInpsFields"
                        :allowFiltering="true"
                        :filtering="categoriaInpsFiltering"
                        placeholder="Categoria INPS"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.persMinConsTipoPersonale  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsTipoPersonale" class="h5"
                        >Tipologia Personale</label
                      >
                      <ejs-dropdownlist
                        id="persMinConsTipoPersonale"
                        ref="persMinConsTipoPersonale"
                        v-model="scrittureActiveData.persMinConsTipoPersonale"
                        :dataSource="personaleMinisteroTipoPersonaleList"
                        :fields="personaleMinisteroTipoPersonaleFields"
                        placeholder="Tipologia Personale"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: scrittureActiveData.persMinConsTipoRapporto  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsTipoRapporto" class="h5"
                        >Tipologia Rapporto</label
                      >
                      <ejs-dropdownlist
                        id="persMinConsTipoRapporto"
                        ref="persMinConsTipoRapporto"
                        v-model="scrittureActiveData.persMinConsTipoRapporto"
                        :dataSource="personaleMinisteroTipoRapportoList"
                        :fields="personaleMinisteroTipoRapportoFields"
                        placeholder="Tipologia Rapporto"
                      />
                    </b-col>

                    <!-- Input di tipo data: scrittureActiveData.persMinConsDataInizio -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsDataInizio" class="h5"
                        >Data Inizio</label
                      >
                      <ejs-datepicker
                        id="persMinConsDataInizio"
                        ref="persMinConsDataInizio"
                        v-model="scrittureActiveData.persMinConsDataInizio"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        placeholder="Data di Inizio"
                        locale='en-US'
                      />
                    </b-col>

                    <!-- Input di tipo data: scrittureActiveData.persMinConsDataFine -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsDataFine" class="h5"
                        >Data Fine</label
                      >
                      <ejs-datepicker
                        id="persMinConsDataFine"
                        ref="persMinConsDataFine"
                        v-model="scrittureActiveData.persMinConsDataFine"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                        placeholder="Data di Fine"
                        locale='en-US'
                      />
                    </b-col>

                    <!-- Input di tipo numero: scrittureActiveData.persMinConsGiornateLavorative -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsGiornateLavorative" class="h5"
                        >Giornate Lavorative</label
                      >
                      <ejs-numerictextbox
                        id="persMinConsGiornateLavorative"
                        ref="persMinConsGiornateLavorative"
                        v-model="
                          scrittureActiveData.persMinConsGiornateLavorative
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Giornate Lavorative"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo valuta: scrittureActiveData.persMinConsOneri -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsOneri" class="h5">Oneri</label>
                      <ejs-numerictextbox
                        id="persMinConsOneri"
                        ref="persMinConsOneri"
                        v-model="scrittureActiveData.persMinConsOneri"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Oneri"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: scrittureActiveData.persMinConsRetribuzione -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="persMinConsRetribuzione" class="h5 mr-1"
                          >Retribuzione</label
                        >
                        <ejs-checkbox
                          id="persMinConsRetribuzione"
                          v-model="scrittureActiveData.persMinConsRetribuzione"
                          ref="persMinConsRetribuzione"
                          :checked="scrittureActiveData.persMinConsRetribuzione"
                          name="persMinConsRetribuzione"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: scrittureActiveData.persMinConsRuolo  -->
                    <b-col
                      xl="12"
                      md="12"
                      class="mb-2"
                      v-show="
                        !this.scrittureActiveData.persMinConsPersonaleDiTerzi
                      "
                    >
                      <label for="persMinConsRuolo" class="h5">Ruolo</label>
                      <ejs-textbox
                        id="persMinConsRuolo"
                        ref="persMinConsRuolo"
                        v-model="scrittureActiveData.persMinConsRuolo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Ruolo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Dettaglio Ministero Consuntivo Oneri -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ministero Consuntivo Oneri</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinConsCostoRetribuzione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsCostoRetribuzione " class="h5">Costo Retribuzione</label>
                      <ejs-numerictextbox
                        id="persMinConsCostoRetribuzione"
                        ref="persMinConsCostoRetribuzione"
                        v-model="scrittureActiveData.persMinConsCostoRetribuzione"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Costo Retribuzione"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinConsCostoContributivo -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsCostoContributivo" class="h5">Costo Contributivo</label>
                      <ejs-numerictextbox
                        id="persMinConsCostoContributivo"
                        ref="persMinConsCostoContributivo"
                        v-model="scrittureActiveData.persMinConsCostoContributivo"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Costo Contributivo"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinConsCostoInail -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsCostoInail" class="h5">Costo Inail</label>
                      <ejs-numerictextbox
                        id="persMinConsCostoInail"
                        ref="persMinConsCostoInail"
                        v-model="scrittureActiveData.persMinConsCostoInail"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Costo Inail"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinConsOneri -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsOneri" class="h5">Oneri</label>
                      <ejs-numerictextbox
                        id="persMinConsOneri"
                        ref="persMinConsOneri"
                        v-model="scrittureActiveData.persMinConsOneri"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Oneri"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinConsRivalsa -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsRivalsa" class="h5">Rivalsa</label>
                      <ejs-numerictextbox
                        id="persMinConsRivalsa"
                        ref="persMinConsRivalsa"
                        v-model="scrittureActiveData.persMinConsRivalsa"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Rivalsa"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                    <!-- Input di tipo valuta: scrittureActiveData.persMinConsOneriTotali -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinConsOneriTotali" class="h5">Oneri Totali</label>
                      <ejs-numerictextbox
                        id="persMinConsOneriTotali"
                        ref="persMinConsOneriTotali"
                        v-model="scrittureActiveData.persMinConsOneriTotali"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Oneri Totali"
                        showSpinButton="false"
                        showClearButton="true"
                        :min="settings.minMoneyNumber"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

          </b-row>
        </b-tab>

        <b-tab title="Oneri Retributivi"
          v-if="this.scrittureActiveId" @click="tabClicked('dialogA1Tab04')">

          <b-row class="match-height">
            <b-col xl="12" md="12" class="pt-1">
              <div id="GridParentOneri">
                <ejs-grid
                  id="gridB" ref="gridB"
                  :dataSource="oneriFullData" :editSettings="gridB.editOptions"
                  :height="gridB.height" locale='it-IT'
                >
                <e-columns>
                  <e-column field="costo_retribuzione" headerText="Costo Retrib" width="150" ></e-column>
                  <e-column field="costo_contributivo" headerText="Costo Contrib" width="150" ></e-column>
                  <e-column field="costo_inail" headerText="Costo INAIL" width="150" ></e-column>
                  <e-column field="oneri" headerText="Oneri" width="150" ></e-column>
                  <e-column field="rivalsa" headerText="Rivalsa" width="150" ></e-column>
                  <e-column field="totale_oneri" headerText="Tot Oneri" width="150" ></e-column>
                  <e-column field="gg" headerText="Giorni Lav." width="150" ></e-column>
                  <e-column field="scrittura" headerText="ID scrittura" width="150" ></e-column>
                </e-columns>
                <e-aggregates>
                  <e-aggregate>
                    <e-columns>
                      <e-column type="Sum" field="costo_retribuzione" format="€ ######.##" ></e-column>
                      <e-column type="Sum" field="costo_contributivo" format="€ ######.##" ></e-column>
                      <e-column type="Sum" field="costo_inail" format="€ ######.##" ></e-column>
                      <e-column type="Sum" field="oneri" format="€ ######.##" ></e-column>
                      <e-column type="Sum" field="rivalsa" format="€ ######.##" ></e-column>
                      <e-column type="Sum" field="gg" ></e-column>
                      <e-column type="Sum" field="totale_oneri" format="€ ######.##" ></e-column>
                    </e-columns>
                  </e-aggregate>
                </e-aggregates>
                </ejs-grid>
              </div>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
 import Vue from "vue";
 import useJwt from "@/auth/jwt/useJwt";
 // import bootstrap-Vue
 import {
   LayoutPlugin,
   TabsPlugin,
   CardPlugin,
   DropdownPlugin,
   LinkPlugin,
   AlertPlugin,
   ProgressPlugin,
   ToastPlugin,
   FormGroupPlugin,
   FormInputPlugin,
   FormCheckboxPlugin,
   FormSelectPlugin,
   FormRatingPlugin,
   SpinnerPlugin,
 } from "bootstrap-vue";
 // import Syncfusion
 import { enableRipple, L10n } from "@syncfusion/ej2-base";
 import { Query } from "@syncfusion/ej2-data";
 import {
   DateTimePickerPlugin,
   DatePickerPlugin,
   TimePickerPlugin,
   CalendarPlugin,
 } from "@syncfusion/ej2-vue-calendars";
 import {
   ButtonPlugin,
   CheckBoxPlugin,
   SwitchPlugin,
 } from "@syncfusion/ej2-vue-buttons";
 import {
   TextBoxPlugin,
   NumericTextBoxPlugin,
   MaskedTextBoxPlugin,
   UploaderPlugin,
 } from "@syncfusion/ej2-vue-inputs";
 import {
   DropDownListPlugin,
   MultiSelectPlugin,
   ListBoxPlugin,
   CheckBoxSelection,
 } from "@syncfusion/ej2-vue-dropdowns";
 import { DialogPlugin } from "@syncfusion/ej2-vue-popups";

 import {
   GridPlugin,
   ForeignKey,
   Edit as GridEdit,
   Toolbar as GridToolbar,
   Sort as GridSort,
   Filter as GridFilter,
   Aggregate,
 } from "@syncfusion/ej2-vue-grids";
 import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

 L10n.load({
   'it-IT': {
     'grid': {
       'ConfirmDelete': 'Sei sicuro di cancellare? Clicca OK per confermare la cancellazione, CANCEL per annullare'
     },
     'calendar': { today: 'oggi' }// per cambiare la lingua nei calendar e data occorre qualche passaggio in più (https://ej2.syncfusion.com/vue/documentation/calendar/globalization)
   }
 });

 const axios = require("axios");
 // use bootstrap-vue
 Vue.use(TabsPlugin);
 Vue.use(CardPlugin);
 Vue.use(LayoutPlugin);
 Vue.use(DropdownPlugin);
 Vue.use(LinkPlugin);
 Vue.use(AlertPlugin);
 Vue.use(ProgressPlugin);
 Vue.use(ToastPlugin);
 Vue.use(FormGroupPlugin);
 Vue.use(FormInputPlugin);
 Vue.use(FormCheckboxPlugin);
 Vue.use(FormSelectPlugin);
 Vue.use(FormRatingPlugin);
 Vue.use(SpinnerPlugin);
 // use Syncfusion
 Vue.use(TextBoxPlugin);
 Vue.use(NumericTextBoxPlugin);
 Vue.use(MaskedTextBoxPlugin);
 Vue.use(UploaderPlugin);
 Vue.use(DatePickerPlugin);
 Vue.use(DateTimePickerPlugin);
 Vue.use(TimePickerPlugin);
 Vue.use(DropDownListPlugin);
 Vue.use(MultiSelectPlugin);
 Vue.use(ButtonPlugin);
 Vue.use(CheckBoxPlugin);
 Vue.use(SwitchPlugin);
 Vue.use(DialogPlugin);
 Vue.use(GridPlugin);
 Vue.use(DropDownButtonPlugin);
 Vue.use(ListBoxPlugin);
 enableRipple(true);
 Vue.use(CalendarPlugin);
 // api
 const apiSoggettiUrl = "/demo/api/soggetto"
 const apiScritturaRicercaUrl = "/demo/api/scrittura/ricerca"
 const apiScritturaExportXlsUrl = "/demo/api/scrittura/exportxls"
 const apiScritturaExportStatsUrl = "/demo/api/costoproduzioni/export_statistiche_xls"
 const apiScritturaUrl = "/demo/api/scrittura"
 const apiDuplicaScritturaUrl = "/demo/api/scrittura/duplica"
 const apiSpettacoloUrl = "/demo/api/spettacolo"
 const apiReciteSpettacoloUrl = "/demo/api/recita/ricerca"
 const contrattiUrl = "/demo/api/contratti"
 const apiOneriUrl = "/demo/api/oneri/ricerca"
 const apiContoBancarioUrl = "/demo/api/contobancario"

 var oldDelay = null

 var itemVue = Vue.component("itemTemplate", {
   template: `<span><span class='denominazione'>{{data.denominazione}}</span><span class ='codFisc'>{{data.codiceFiscale}}</span></span>`,
   data() {
     return {
       data: {},
     };
   },
 });

 var valueVue = Vue.component("valueTemplate", {
   template: `<span><span class='denominazione'>{{data.denominazione}}</span></span>`,
   data() {
     return {
       data: {},
     };
   },
 });

 var recitaItem = Vue.component("recitaTemplate", {
   template: `<span><span>data: {{data.dataStringa}}</span>&nbsp&nbsp&nbsp<span>ora: {{data.orarioStringa}}</span></span>`,
   data() {
     return {
       data: {},
     };
   },
 });

 export default Vue.extend({
   components: {},
   data() {
     return {
       filtroGrid: "nessunFiltro",
       // generali
       settings: {
         formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
         formatoOra: { skeleton: "Hm" },
         //formatoOra: 'HH:mm',
         formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
         intervalloOra: 15,
         listboxSelectionSettings: { showCheckbox: true },
         minDayInteger: 0,
         maxDayInteger: 100,
         stepDayInteger: 1,
         minMoneyNumber: 0,
         firstDayOfWeek: 1,
       },
       nonMostrare: false,
       // per mostra ruolo
       showRuolo: false,
       // per mostra download bozza contratto
       //showModificato: false,
       //showFirmato: false,
       // per dropdownlist con template
       itemTemplate: function () {
         return { template: itemVue };
       },
       valueTemplate: function () {
         return { template: valueVue };
       },
       recitaTemplate: function () {
         return { template: recitaItem };
       },
       // spinner
       loading: false,
       // per inizializzazione dropdown a null
       initIndex: -1,
       // per gestione stagioni
       stagioniData: [
         { label: "Anno 2022", val: "2022" },
         { label: "Anno 2023", val: "2023" },
         { label: "Anno 2024", val: "2024" },
         { label: "Anno 2025", val: "2025" },
         { label: "Anno 2026", val: "2026" },
         { label: "Anno 2027", val: "2027" },
       ],
       stagioniFields: { value: "val", text: "label" },
       stagioniIndex: -1,
       queryStagioni: null,
       stagioneCorrente: null,
       // per gestione spettacoli
       elencoSpettacoliList: [],
       elencoSpettacoliFields: { value: "id", text: "titolo" },
       spettacoliIndex: -1,
       dropSpettacoliEnabled: false,
       downloadxlsEnabled: false,
       querySpettacoli: null,
       spettacoloCorrente: null,
       spettacoloCorrenteHasMinistero: null,
       // per gestione soggetti filtrati (al momento artisti e tecnici)
       elencoSoggFiltratiList: [],
       elencoSoggFiltratiFields: { text: "denominazione", value: "id" },
       // per gestione recite
       dettReciteList: [],
       dettReciteFields: { value: "dataRiepilogo", text: "dataRiepilogo" },
       // scritture
       scrittureFullData: [], // elenco completo dati scritture
       scrittureActiveId: 0, // Id scrittura attivo (0 se nuovo)
       scrittureActiveData: {}, // dati completi della scrittura attiva
       scrittureSavedData: {},
       oneriPreventivoActiveData: {},
       // oneri
       oneriFullData: [],
       // blocco modifica
       setBloccoModifica: false,
       bloccoModifica: false,

       delayPagamentoList: [
         { label: '30gg', value: 30 },
         { label: '60gg', value: 60 },
         { label: '90gg', value: 90 },
       ],
       delayPagamentoFields: { text: "label", value: "value" },
       // pagato
       pagatoList: [
         { label: "Si", id: "si" },
         { label: "No", id: "no" },
         { label: "Acconto", id: "acconto" },
       ],
       pagatoFields: { text: "label", value: "id" },
       // conti bancari (campo contoPagamento)
       elencoContiBancari: [],
       contoBancarioFields: { text: "nome", value: "id" },
       // contratti
       contrattiActiveData: {},
       // struttura etichetta - valore per dropdown
       labelValFields: { value: "val", text: "label" },
       // campi tipologia
       ruoloList: [
         { label: "Protagonista", val: "protagonista" },
         { label: "Solista", val: "solista" },
         { label: "Altro ruolo", val: "altro" },
       ],
       qualificaList: [
         { label: "Operaio", val: "Operaio" },
         { label: "Impiegato", val: "Impiegato" },
         // estendere con lista qualifica .............................. <---------------------
       ],
       regimeFiscaleList: [
         // elenco di xxx
         { label: "Non Specificato", val: "nonSpecificato" },
         { label: "Italiano Ordinario", val: "ordinario" },
         { label: "Italiano Forfettario", val: "forfettario" },
         { label: "Italiano Occasionale", val: "occasionale" },
         { label: "Straniero", val: "straniero" },
       ],
       esenzioneList: [
         // elenco di xxx
         { label: "A1", val: "A1" },
         { label: "Altro", val: "altro" },
         { label: "Nessuna", val: "nessuna" },
       ],
       personaleMinisteroNazionalitaList: [
         { label: "Italiana o UE", id: "eu" },
         { label: "Extra UE", id: "extraeu" },
       ], // elenco delle nazionalità
       personaleMinisteroNazionalitaFields: { text: "label", value: "id" }, // specifica i campi da estrarre per popolare la lista della nazionalità
       categoriaInpsList: [
         {
           label: "011 artisti lirici",
           id: "011",
           cat: "Gruppo canto",
           group: "Raggruppamento A",
         },
         {
           label: "012 cantanti di musica leggera",
           id: "012",
           cat: "Gruppo canto",
           group: "Raggruppamento A",
         },
         {
           label: "013 coristi, vocalisti",
           id: "013",
           cat: "Gruppo canto",
           group: "Raggruppamento A",
         },
         {
           label:
            "014 maestri del coro, assistenti e aiuti del coro, suggeritori del coro",
           id: "014",
           cat: "Gruppo canto",
           group: "Raggruppamento A",
         },
         {
           label: "021 attori di prosa, mimi, allievi attori",
           id: "021",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "022 attori cinematografici o di audiovisivi",
           id: "022",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "023 attori di doppiaggio",
           id: "023",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "024 attori di operetta",
           id: "024",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "025 attori di rivista, attori di varietà ed attrazioni",
           id: "025",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "026 artisti del circo",
           id: "026",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "027 attori di fotoromanzi",
           id: "027",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "028 suggeritori teatrali, cinematografici o di audiovisivi",
           id: "028",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "029 generici, figuranti",
           id: "029",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "821 imitatori, ipnotizzatori, illusionisti e prestigiatori",
           id: "821",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "822 marionettisti, burattinai",
           id: "822",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "823 acrobati, stuntman, contorsionisti",
           id: "823",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "824 maestri d'armi",
           id: "824",
           cat: "Gruppo attori",
           group: "Raggruppamento A",
         },
         {
           label: "031 presentatori",
           id: "031",
           cat: "Gruppo conduttori e animatori",
           group: "Raggruppamento A",
         },
         {
           label: "032 disc-jockey",
           id: "032",
           cat: "Gruppo conduttori e animatori",
           group: "Raggruppamento A",
         },
         {
           label: "033 animatori in strutture turistiche e di spettacolo",
           id: "033",
           cat: "Gruppo conduttori e animatori",
           group: "Raggruppamento A",
         },
         {
           label: "041 registi teatrali, cinematografici o di audiovisivi",
           id: "041",
           cat: "Gruppo registi e sceneggiatori",
           group: "Raggruppamento A",
         },
         {
           label: "042 aiuti registi teatrali, cinematografici o di audiovisivi",
           id: "042",
           cat: "Gruppo registi e sceneggiatori",
           group: "Raggruppamento A",
         },
         {
           label: "043 sceneggiatori teatrali, cinematografici o di audiovisivi",
           id: "043",
           cat: "Gruppo registi e sceneggiatori",
           group: "Raggruppamento A",
         },
         {
           label: "044 dialoghisti, adattatori cinetelevisivi o di audiovisivi",
           id: "044",
           cat: "Gruppo registi e sceneggiatori",
           group: "Raggruppamento A",
         },
         {
           label: "045 direttori della fotografia, light designer",
           id: "045",
           cat: "Gruppo registi e sceneggiatori",
           group: "Raggruppamento A",
         },
         {
           label: "046 soggettisti",
           id: "046",
           cat: "Gruppo registi e sceneggiatori",
           group: "Raggruppamento A",
         },
         {
           label: "047 video-assist",
           id: "047",
           cat: "Gruppo registi e sceneggiatori",
           group: "Raggruppamento A",
         },
         {
           label: "051 direttori di produzione",
           id: "051",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label: "052 ispettori di produzione",
           id: "052",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label: "053 segretari di produzione",
           id: "053",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label: "054 segretari di edizione",
           id: "054",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label: "055 cassieri di produzione",
           id: "055",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label: "056 organizzatori generali, location manager",
           id: "056",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label:
            "057 responsabili di edizione della produzione cinematografica e televisiva",
           id: "057",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label: "058 casting director",
           id: "058",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label: "059 documentalisti audiovisivi",
           id: "059",
           cat: "Gruppo produzione cinematografica, di audiovisivi e di spettacolo",
           group: "Raggruppamento A",
         },
         {
           label: "061 direttori di scena",
           id: "061",
           cat: "Gruppo direttori di scena e di doppiaggio",
           group: "Raggruppamento A",
         },
         {
           label: "062 direttori di doppiaggio",
           id: "062",
           cat: "Gruppo direttori di scena e di doppiaggio",
           group: "Raggruppamento A",
         },
         {
           label: "063 assistenti di scena e di doppiaggio",
           id: "063",
           cat: "Gruppo direttori di scena e di doppiaggio",
           group: "Raggruppamento A",
         },
         {
           label: "071 direttori d'orchestra",
           id: "071",
           cat: "Gruppo direttori e maestri di orchestra",
           group: "Raggruppamento A",
         },
         {
           label: "072 sostituti direttori d'orchestra",
           id: "072",
           cat: "Gruppo direttori e maestri di orchestra",
           group: "Raggruppamento A",
         },
         {
           label: "073 maestri collaboratori",
           id: "073",
           cat: "Gruppo direttori e maestri di orchestra",
           group: "Raggruppamento A",
         },
         {
           label: "074 maestri di banda",
           id: "074",
           cat: "Gruppo direttori e maestri di orchestra",
           group: "Raggruppamento A",
         },
         {
           label: "075 compositori",
           id: "075",
           cat: "Gruppo direttori e maestri di orchestra",
           group: "Raggruppamento A",
         },
         {
           label: "081 concertisti e solisti",
           id: "081",
           cat: "Gruppo concertisti e orchestrali",
           group: "Raggruppamento A",
         },
         {
           label: "082 professori d'orchestra",
           id: "082",
           cat: "Gruppo concertisti e orchestrali",
           group: "Raggruppamento A",
         },
         {
           label: "083 orchestrali (anche di musica leggera)",
           id: "083",
           cat: "Gruppo concertisti e orchestrali",
           group: "Raggruppamento A",
         },
         {
           label: "084 bandisti",
           id: "084",
           cat: "Gruppo concertisti e orchestrali",
           group: "Raggruppamento A",
         },
         {
           label: "085 consulenti assistenti musicali",
           id: "085",
           cat: "Gruppo concertisti e orchestrali",
           group: "Raggruppamento A",
         },
         {
           label: "091 coreografi e assistenti coreografi",
           id: "091",
           cat: "Gruppo ballo figurazione e moda",
           group: "Raggruppamento A",
         },
         {
           label: "092 ballerini e tersicorei",
           id: "092",
           cat: "Gruppo ballo figurazione e moda",
           group: "Raggruppamento A",
         },
         {
           label: "093 indossatori",
           id: "093",
           cat: "Gruppo ballo figurazione e moda",
           group: "Raggruppamento A",
         },
         {
           label: "094 figuranti lirici",
           id: "094",
           cat: "Gruppo ballo figurazione e moda",
           group: "Raggruppamento A",
         },
         {
           label: "095 figuranti di sala",
           id: "095",
           cat: "Gruppo ballo figurazione e moda",
           group: "Raggruppamento A",
         },
         {
           label: "096 fotomodelli",
           id: "096",
           cat: "Gruppo ballo figurazione e moda",
           group: "Raggruppamento A",
         },
         {
           label: "097 cubisti",
           id: "097",
           cat: "Gruppo ballo figurazione e moda",
           group: "Raggruppamento A",
         },
         {
           label: "098 spogliarellisti",
           id: "098",
           cat: "Gruppo ballo figurazione e moda",
           group: "Raggruppamento A",
         },
         {
           label: "101 amministratori di formazioni artistiche",
           id: "101",
           cat: "Gruppo amministratori",
           group: "Raggruppamento A",
         },
         {
           label:
            "102 amministratori di produzione cinematografica e audiovisiva",
           id: "102",
           cat: "Gruppo amministratori",
           group: "Raggruppamento A",
         },
         {
           label: "103 organizzatori teatrali",
           id: "103",
           cat: "Gruppo amministratori",
           group: "Raggruppamento A",
         },
         {
           label: "104 amministratori e segretari di compagnie teatrali",
           id: "104",
           cat: "Gruppo amministratori",
           group: "Raggruppamento A",
         },
         {
           label:
            "111 tecnici del montaggio, del suono e sound designer della produzione cinematografica",
           id: "111",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label:
            "112 tecnici del montaggio, del suono e sound designer del teatro",
           id: "112",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label:
            "113 tecnici del montaggio, del suono e sound designer di audiovisivi",
           id: "113",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label:
            "114 tecnici del montaggio e del suono di altri settori dello spettacolo",
           id: "114",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label:
            "115 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici della produzione cinematografica",
           id: "115",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label:
            "116 tecnici di luci, scena, effetti speciali ed altri tecnici del teatro",
           id: "116",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label:
            "117 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici di audiovisivi",
           id: "117",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label:
            "118 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici di fotoromanzi",
           id: "118",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label: "119 tecnici addetti alle manifestazioni di moda",
           id: "119",
           cat: "Gruppo tecnici",
           group: "Raggruppamento A",
         },
         {
           label: "121 operatori di ripresa cinematografica o audiovisiva",
           id: "121",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento A",
         },
         {
           label: "122 aiuto operatori di ripresa cinematografica o audiovisiva",
           id: "122",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento A",
         },
         {
           label: "123 maestranze cinematografiche",
           id: "123",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento A",
         },
         {
           label: "124 maestranze teatrali",
           id: "124",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento A",
         },
         {
           label: "125 maestranze di imprese audiovisive",
           id: "125",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento A",
         },
         {
           label: "126 fotografi di scena",
           id: "126",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento A",
         },
         {
           label: "131 architetti, arredatori",
           id: "131",
           cat: "Gruppi scenografi, arredatori e costumisti",
           group: "Raggruppamento A",
         },
         {
           label:
            "132 costumisti, modisti, figurinisti e sarti teatrali, cinematografici o di audiovisivi",
           id: "132",
           cat: "Gruppi scenografi, arredatori e costumisti",
           group: "Raggruppamento A",
         },
         {
           label: "133 scenografi",
           id: "133",
           cat: "Gruppi scenografi, arredatori e costumisti",
           group: "Raggruppamento A",
         },
         {
           label: "134 bozzettista",
           id: "134",
           cat: "Gruppi scenografi, arredatori e costumisti",
           group: "Raggruppamento A",
         },
         {
           label: "135 story board artist",
           id: "135",
           cat: "Gruppi scenografi, arredatori e costumisti",
           group: "Raggruppamento A",
         },
         {
           label:
            "136 creatori di fumetti, illustrazioni e disegni finalizzati all'animazione",
           id: "136",
           cat: "Gruppi scenografi, arredatori e costumisti",
           group: "Raggruppamento A",
         },
         {
           label: "141 truccatori",
           id: "141",
           cat: "Gruppo truccatori e parrucchieri",
           group: "Raggruppamento A",
         },
         {
           label: "142 parrucchieri",
           id: "142",
           cat: "Gruppo truccatori e parrucchieri",
           group: "Raggruppamento A",
         },
         {
           label: "500 lavoratori autonomi esercenti attività musicali",
           id: "500",
           cat: "Gruppo lavoratori autonomi esercenti attività musicali",
           group: "Raggruppamento A",
         },
         {
           label: "154 artieri ippici",
           id: "154",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento B",
         },
         {
           label: "155 operatori di cabine di sale cinematografiche",
           id: "155",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento B",
         },
         {
           label:
            "156 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio",
           id: "156",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento B",
         },
         {
           label:
            "157 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio dipendenti dagli enti ed imprese esercenti pubblici spettacoli",
           id: "157",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento B",
         },
         {
           label:
            "158 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio dipendenti dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa",
           id: "158",
           cat: "Gruppo operatori e maestranze",
           group: "Raggruppamento B",
         },
         {
           label:
            "201 impiegati amministrativi e tecnici dipendenti dalle imprese radiofoniche, televisive o di audiovisivi",
           id: "201",
           cat: "Gruppo impiegati",
           group: "Raggruppamento B",
         },
         {
           label:
            "202 impiegati amministrativi e tecnici dipendenti dagli enti ed imprese esercenti pubblici spettacoli",
           id: "202",
           cat: "Gruppo impiegati",
           group: "Raggruppamento B",
         },
         {
           label:
            "203 impiegati amministrativi e tecnici dipendenti dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa",
           id: "203",
           cat: "Gruppo impiegati",
           group: "Raggruppamento B",
         },
         {
           label:
            "204 autisti dipendenti dagli enti ed imprese esercenti pubblici spettacoli, dalle imprese radiofoniche, televisive o di audiovisivi, dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa",
           id: "204",
           cat: "Gruppo impiegati",
           group: "Raggruppamento B",
         },
         {
           label:
            "205 operai dipendenti dagli enti ed imprese esercenti pubblici spettacoli, dalle imprese radiofoniche, televisive o di audiovisivi, dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa",
           id: "205",
           cat: "Gruppo impiegati",
           group: "Raggruppamento B",
         },
         {
           label:
            "211 impiegati dipendenti da ippodromi, scuderie di cavalli da corsa e cinodromi",
           id: "211",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label:
            "212 operai dipendenti da ippodromi, scuderie di cavalli da corsa e cinodromi",
           id: "212",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label:
            "213 impiegati dipendenti dalle imprese di spettacoli viaggianti",
           id: "213",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label: "214 operai dipendenti dalle imprese di spettacoli viaggianti",
           id: "214",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label: "217 impiegati dipendenti dalle case da gioco",
           id: "217",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label: "218 operai dipendenti dalle case da gioco",
           id: "218",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label:
            "219 prestatori d'opera addetti ai totalizzatori o alla ricezione delle scommesse, presso gli ippodromi e cinodromi, nonché presso le sale da corsa e le agenzie ippiche",
           id: "219",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label: "235 impiegati dipendenti dalle sale scommesse",
           id: "235",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label: "236 operai dipendenti dalle sale scommesse",
           id: "236",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label: "237 impiegati dipendenti dalle sale giochi",
           id: "237",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label: "238 operai dipendenti dalle sale giochi",
           id: "238",
           cat: "Gruppo dipendenti imprese di spettacoli viaggianti..",
           group: "Raggruppamento B",
         },
         {
           label:
            "215 impiegati dipendenti da impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi",
           id: "215",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label:
            "216 operai dipendenti da impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi",
           id: "216",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label:
            "771 istruttori presso impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi",
           id: "771",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label:
            "772 addetti agli impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi",
           id: "772",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label: "773 impiegati dipendenti da società sportive",
           id: "773",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label: "774 operai dipendenti da società sportive",
           id: "774",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label: "775 direttori tecnici presso società sportive",
           id: "775",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label: "776 massaggiatori presso società sportive",
           id: "776",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label: "777 istruttori presso società sportive",
           id: "777",
           cat: "Gruppo lavoratori degli impianti e circoli sportivi",
           group: "Raggruppamento B",
         },
         {
           label:
            "231 impiegati dipendenti dalle imprese esercenti il noleggio e la distribuzione dei film",
           id: "231",
           cat: "Gruppo dipendenti da imprese di noleggio films",
           group: "Raggruppamento B",
         },
         {
           label:
            "232 operai dipendenti dalle imprese esercenti il noleggio e la distribuzione dei film",
           id: "232",
           cat: "Gruppo dipendenti da imprese di noleggio films",
           group: "Raggruppamento B",
         },
       ], // elenco codici INPS
       categoriaInpsFields: { groupBy: "cat", text: "label", value: "id" }, // specifica i campi da estrarre per popolare la lista dei codici INPS
       mansioneList: [
         { label: "Attore", val: "Attore" },
         { label: "Aiuto Regia", val: "Aiuto Regia" },
         { label: "Aiuto Sarta", val: "Aiuto Sarta" },
         { label: "Aiuto Scenografo", val: "Aiuto Scenografo" },
         { label: "Aiuto Trucco e Parrucco", val: "Aiuto Trucco e Parrucco" },
         { label: "Assistente Costumista", val: "Assistente Costumista" },
         { label: "Assistente Regia", val: "Assistente Regia" },
         { label: "Assistente Scenografo", val: "Assistente Scenografo" },
         { label: "Attrezzista", val: "Attrezzista" },
         { label: "Cantante lirico", val: "Cantante lirico" },
         { label: "Concertista", val: "Concertista" },
         { label: "Coreografo", val: "Coreografo" },
         { label: "Coro", val: "Coro" },
         { label: "Coro delle Voci Bianche", val: "Coro delle Voci Bianche" },
         { label: "Corpo di Ballo", val: "Corpo di Ballo" },
         { label: "Costumista", val: "Costumista" },
         { label: "Danzatore", val: "Danzatore" },
         { label: "Direttore d’Orchestra", val: "Direttore d’Orchestra" },
         { label: "Direttore di Scena", val: "Direttore di Scena" },
         { label: "Drammaturgo", val: "Drammaturgo" },
         { label: "Elettricista", val: "Elettricista" },
         { label: "Ensemble Orchestrale", val: "Ensemble Orchestrale" },
         { label: "Figurante", val: "Figurante" },
         { label: "Fonico", val: "Fonico" },
         { label: "Librettista", val: "Librettista" },
         { label: "Lighting", val: "Lighting" },
         { label: "Macchinista", val: "Macchinista" },
         { label: "Maestro Collaboratore", val: "Maestro Collaboratore" },
         { label: "Maestro del Coro", val: "Maestro del Coro" },
         { label: "Maestro di Sala", val: "Maestro di Sala" },
         { label: "Maestro delle Luci", val: "Maestro delle Luci" },
         { label: "Maestro del Palco", val: "Maestro del Palco" },
         { label: "Maestro dei Sovratitoli", val: "Maestro dei Sovratitoli" },
         { label: "Musicologo", val: "Musicologo" },
         { label: "Orchestrale", val: "Orchestrale" },
         { label: "Regista", val: "Regista" },
         { label: "Sarta", val: "Sarta" },
         { label: "Scenografo", val: "Scenografo" },
         { label: "Solista", val: "Solista" },
         { label: "Tersicorei", val: "Tersicorei" },
         { label: "Trucco e Parrucco", val: "Trucco e Parrucco" },
         { label: "Video Designer", val: "Video Designer" },
         { label: "Voce Recitante", val: "Voce Recitante" },
       ],
       inQualitaList: [
         { label: "Attore", val: "Attore" },
         { label: "Aiuto Regia", val: "Aiuto Regia" },
         { label: "Aiuto Sarta", val: "Aiuto Sarta" },
         { label: "Aiuto Scenografo", val: "Aiuto Scenografo" },
         { label: "Aiuto Trucco e Parrucco", val: "Aiuto Trucco e Parrucco" },
         { label: "Assistente Costumista", val: "Assistente Costumista" },
         { label: "Assistente Regia", val: "Assistente Regia" },
         { label: "Assistente Scenografo", val: "Assistente Scenografo" },
         { label: "Attrezzista", val: "Attrezzista" },
         { label: "Cantante lirico", val: "Cantante lirico" },
         { label: "Concertista", val: "Concertista" },
         { label: "Coreografo", val: "Coreografo" },
         { label: "Coro", val: "Coro" },
         { label: "Coro delle Voci Bianche", val: "Coro delle Voci Bianche" },
         { label: "Corpo di Ballo", val: "Corpo di Ballo" },
         { label: "Costumista", val: "Costumista" },
         { label: "Danzatore", val: "Danzatore" },
         { label: "Direttore d’Orchestra", val: "Direttore d’Orchestra" },
         { label: "Direttore di Scena", val: "Direttore di Scena" },
         { label: "Drammaturgo", val: "Drammaturgo" },
         { label: "Elettricista", val: "Elettricista" },
         { label: "Ensemble Orchestrale", val: "Ensemble Orchestrale" },
         { label: "Figurante", val: "Figurante" },
         { label: "Fonico", val: "Fonico" },
         { label: "Librettista", val: "Librettista" },
         { label: "Lighting", val: "Lighting" },
         { label: "Macchinista", val: "Macchinista" },
         { label: "Maestro Collaboratore", val: "Maestro Collaboratore" },
         { label: "Maestro del Coro", val: "Maestro del Coro" },
         { label: "Maestro di Sala", val: "Maestro di Sala" },
         { label: "Maestro delle Luci", val: "Maestro delle Luci" },
         { label: "Maestro del Palco", val: "Maestro del Palco" },
         { label: "Maestro dei Sovratitoli", val: "Maestro dei Sovratitoli" },
         { label: "Musicologo", val: "Musicologo" },
         { label: "Orchestrale", val: "Orchestrale" },
         { label: "Regista", val: "Regista" },
         { label: "Sarta", val: "Sarta" },
         { label: "Scenografo", val: "Scenografo" },
         { label: "Solista", val: "Solista" },
         { label: "Tersicorei", val: "Tersicorei" },
         { label: "Trucco e Parrucco", val: "Trucco e Parrucco" },
         { label: "Video Designer", val: "Video Designer" },
         { label: "Voce Recitante", val: "Voce Recitante" },
       ],
       tipologiaDirittiList: [
         { label: "Diritti Aiuto Regia", val: "Diritti Aiuto Regia" },
         { label: "Diritti Aiuto Scenografo", val: "Diritti Aiuto Scenografo" },
         { label: "Diritti Compositore", val: "Diritti Compositore" },
         { label: "Diritti Coreografo", val: "Diritti Coreografo" },
         { label: "Diritti Costumista", val: "Diritti Costumista" },
         { label: "Diritti Direttore Orchestra", val: "Diritti Direttore Orchestra" },
         { label: "Diritti Drammaturgia", val: "Diritti Drammaturgia" },
         { label: "Diritti Librettista", val: "Diritti Librettista" },
         { label: "Diritti Lighting", val: "Diritti Lighting" },
         { label: "Diritti Musicologo", val: "Diritti Musicologo" },
         { label: "Diritti Regia", val: "Diritti Regia" },
         { label: "Diritti Scenografo", val: "Diritti Scenografo" },
         { label: "Diritti Video Designer", val: "Diritti Video Designer" },
         { label: "Altri Diritti", val: "Altri Diritti" },
       ],
       // tipologia contributo soggetto
       tipologiaContributoList: [
         { label: "Tab C - Lavoratori iscritti dopo il 31/12/95", val: "tabC" },
         {
           label: "Tab D - Autonomi già iscritti al 31/12/95 Ex 1° gruppo",
           val: "tabD",
         },
         {
           label: "Tab G - Dipendenti già iscritti al 31/12/95 Ex 2° gruppo",
           val: "tabG",
         },
         {
           label:
            "Tab R - Ballerini e Tersicorei, coreografi e assistenti coreografi",
           val: "tabR",
         },
         { label: "Sconosciuta", val: "sconosciuta" },
       ],
       // lista valori tipologia cast
       tipoCastList: [
         { label: "Cast Artistico", val: "castArtistico" },
         { label: "Team Creativo", val: "castCreativo" },
         { label: "Altri Creativi", val: "castCreativoAltri" },
         { label: "Tecnico", val: "castTecnico" },
       ],
       // lista valori stato scrittura
       scrittureStatoList: [
         { label: "Bozza", val: "bozza" },
         { label: "Confermato", val: "confermato" },
         { label: "Validato", val: "validato" },
         { label: "Annullato", val: "annullato" },
       ],
       // lista valori tipoCompAll1
       scrittureTipoCompAll1List: [
         { label: "Lordo", val: "lordo" },
         { label: "Netto", val: "netto" },
       ],
       // tipologia orario
       tipoOrarioList: [
         { label: "Tempo pieno", id: "tempo pieno" },
         { label: "Part-time", id: "tempo parziale" },
       ],
       tipoOrarioFields: { text: "label", value: "id" },
       // tipologie scritture
       tipoScritturaList: [
         { label: "1 - Subordinato tecnici a prestazione", id: "1" },
         { label: "2 - Subordinato tecnici a tempo determinato", id: "2" },
         { label: "3 - Autonomi tecnici compenso giornaliero", id: "3" },
         { label: "4 - Autonomi artisti compenso giornaliero", id: "4" },
         { label: "5 - Autonomi artisti compenso complessivo", id: "5" },
         { label: "6 - Autonomi artisti compenso recita", id: "6" },
         { label: "7 - Diritti d'autore", id: "7" },
         { label: "8 - Coro", id: "8" },
         { label: "9 - Orchestra", id: "9" },
         { label: "10 - Corpo di ballo", id: "10" },
         { label: "11 - Dipendenti Interni", id: "11" },
         { label: "12 - Compagnie Ospiti", id: "12" },
         { label: "13 - Relatori - Conferenzieri", id: "13" },
         { label: "14 - Compagnie Ospiti", id: "14" },
       ],
       tipoScritturaFields: { text: "label", value: "id" },
       // livello
       livelloList: [
         { id: "1", label: "livello 1" },
         { id: "2", label: "livello 2" },
         { id: "3", label: "livello 3" },
         { id: "4", label: "livello 4" },
         { id: "5", label: "livello 5" },
         { id: "6", label: "livello 6" },
         { id: "7", label: "livello 7" },
       ],
       livelloList2: [
         { id: "3", label: "livello 3" },
         { id: "4", label: "livello 4" },
         { id: "5", label: "livello 5" },
         { id: "6", label: "livello 6" },
         { id: "7", label: "livello 7" },
       ],
       livelloFields: { text: "label", value: "id" },
       // personale ministero
       personaleMinisteroTipoPersonaleList: [
         { label: "Amministrativo", id: "amministrativo" },
         { label: "Artistico", id: "artistico" },
         { label: "Artistico Lirico", id: "artisticoLirico" },
         { label: "Professore di orchestra", id: "professoreOrchestra" },
         { label: "Tecnico", id: "tecnico" },
       ], // elenco tipologia personale
       personaleMinisteroTipoPersonaleFields: { text: "label", value: "id" }, // specifica i campi da estrarre per popolare la lista tipologia personale
       personaleMinisteroTipoRapportoList: [
         { label: "Altro", id: "altro" },
         { label: "Coproduzione", id: "coproduzione" },
         { label: "Determinato", id: "determinato" },
         { label: "Indeterminato", id: "indeterminato" },
         { label: "Prestazione Occasionale", id: "prestazioneOccasionale" },
       ], // elenco tipologia rapporto
       personaleMinisteroTipoRapportoFields: { text: "label", value: "id" }, // specifica i campi da estrarre per popolare la lista tipologia rapporto
       // Elenco filtri grid
       filtroGridList: [
         { label: "Nessuno", id: "nessunFiltro" },
         { label: "Filtro Stato", id: "filtroStato" },
         { label: "Filtro Cast", id: "filtroCast" },
       ],
       filtroGridFields: { text: "label", value: "id" },
       // per alertA
       alertADismissSecs: 3,
       alertADismissCountDown: 0,
       // per dialogA1
       dialogA1: {
         header: "",
         visible: false,
         showCloseIcon: true,
         buttons: [
           {
             click: this.dialogA1Ok,
             buttonModel: { content: "OK", isPrimary: true },
           },
           { click: this.dialogA1Cancel, buttonModel: { content: "Cancel" } },
         ],
         animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
         zIndex: 1050,
         tabAdialogA1Index: 0,
         isVisible: null, // per controllare eventi onXXchange
       },
       // per gridA
       gridAFlag: false,
       gridA: {
         height: 600,
         editOptions: {
           allowEditing: false,
           allowDeleting: true,
           showDeleteConfirmDialog: true,
         },
         filterOptions: { type: "Excel" },
         toolbarOptions: [
           {
             text: "Nuova Scrittura",
             tooltipText: "Inserisci nuova scrittura",
             prefixIcon: "e-plus",
             id: "new",
           },
           {
             text: "Apri Scrittura",
             tooltipText: "Apri scrittura",
             prefixIcon: "e-expand",
             id: "edit",
           },
           {
             text: "Cancella Scrittura",
             tooltipText: "Cancella scrittura",
             prefixIcon: "e-cancel",
             id: "delete",
           },
           {
             text: "Duplica Scrittura",
             tooltipText: "Duplica scrittura",
             prefixIcon: "e-expand",
             id: "duplica",
           },          
           "Search",
         ],
         //sortOptions: { columns: [{ field: "id", direction: "Ascending" }] },
         sortOptions: {
           columns: [
             { field: "tipoCast", direction: "Ascending" },
             { field: "soggetto", direction: "Ascending" },
           ],
         },
       }, //
       gridB: {
         height: 400,
       },
 };
 },
  created() {
    // permessi per modificare switch bloccoModifica
    const userData = localStorage.getItem("userData")
    if (userData !== null) {
      const uD = JSON.parse(userData)
      // console.log("username")
      // console.log(uD.username)
      if ((uD.username === "ricercaSviluppo") ||
          (uD.username === "amministratore") ||
          (uD.username === "segrDirezione") ||
          (uD.username === "contratti")) {
        this.setBloccoModifica = true
        console.log("bloccoModifica TRUE")
      } else {
        this.setBloccoModifica = false
        console.log("bloccoModifica false")
      }
    }


    // log
    console.log("Pagina Scritture Creata");
    // inizializzazione elenchi dal backend
    // chiamate API
    console.log("Recupero elenchi dal backend");
    // conti bancari
    useJwt.get(apiContoBancarioUrl).then((d) => {
      this.elencoContiBancari = d.data;
    });
    // spettacoli
    useJwt.get(apiSpettacoloUrl).then((d) => {
      // console.log("Elenco Spettacoli");
      // console.log(d.data);
      this.elencoSpettacoliList = d.data;
    });
    // soggetti filtrati (artisti e tecnici)
    useJwt.get(apiSoggettiUrl).then((d) => {
      // console.log("Elenco soggetti anagrafica");
      // console.log(d.data);
      // filtro in base a isArtista o isTecnico
      const results = d.data.filter((obj) => {
        return obj.isArtista === true || obj.isTecnico === true;
      });
      this.elencoSoggFiltratiList = results;
      // this.elencoSoggFiltratiList.forEach((obj) => {
      //   if (obj.ragioneSociale) {
      //     console.log("artista con ragioneSociale")
      //     console.log(obj);
      //   }
      // })
    });
  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add("disablegrid");
    document.getElementById("GridParent").classList.add("wrapper");
    // focus su dropStagioni
    this.$refs.dropStagioni.ej2Instances.focusIn();

  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Aggregate],
    // per listBox
    listbox: [CheckBoxSelection],
  },
  methods: {
    sortComparer: function(reference, comparer) {
      // castCreativoAltri deve venire dopo Cast Artistico e dopo Team Creativo (viene prima solo di castTecnico)
      // console.log(reference)
      if ((reference == 'castCreativoAltri') && (comparer !== 'castTecnico')) {
        return 1;
      }
      if (reference < comparer) {
        return -1;
      }
      if (reference > comparer) {
        return 1;
      }
      return 0;
    },
    aggiornaGrid: function () {
      this.$refs.gridA.ej2Instances.refresh();
    },
    rowDataBound: function (args) {
      // gestione filtroStato
      if (this.filtroGrid == "filtroStato") {
        if (args.data['stato'] == "confermato") {
          args.row.classList.add('rigaVerde');
        } else if (args.data['stato'] == "bozza") {
          args.row.classList.add('rigaGrigia');
        }
      }
      // gestione filtroCast
      else if (this.filtroGrid == "filtroCast") {
        if (args.data['tipoCast'] == "castArtistico") {
          args.row.classList.add('rigaCeleste');
        } else if (args.data['tipoCast'] == "castCreativo") {
          args.row.classList.add('rigaViola');
        }
        else {
          args.row.classList.add('rigaGrigia');
        }
      }
      // visualizzazione ordinaria
      else {
        args.row.classList.add('rigaPulita');
      }
    },
    roundNumber: function(val) {
      return Math.round(val * 100) / 100;
    },
    downloadXls: function(compact) {
      let datiDaInviare = {stagione: this.stagioneCorrente}
      if (compact) {
        datiDaInviare['tipologia'] = 'compact'
      }
      useJwt.post(apiScritturaExportXlsUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore stagione non selezionata")
      });
    },
    downloadStats: function() {
      let datiDaInviare = {stagione: this.stagioneCorrente}

      useJwt.post(apiScritturaExportStatsUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore stagione non selezionata")
      });
    },

    aggiornaInfoMinistero(s) {
      this.scrittureActiveData.persMinPrevNome = s.nome
      this.scrittureActiveData.persMinPrevCognome = s.cognome
      this.scrittureActiveData.persMinPrevCodiceFiscale = s.codiceFiscale
      this.scrittureActiveData.persMinPrevPartitaIva = s.partitaIva
      this.scrittureActiveData.persMinPrevDataNascita = s.dataNascita
      this.scrittureActiveData.persMinPrevNazionalita = s.nazionalita
      if (s.cittadinanza.toLowerCase().includes("italia")) {
        this.scrittureActiveData.persMinPrevPersonaleStraniero = false
      } else {
        this.scrittureActiveData.persMinPrevPersonaleStraniero = true
      }

      this.scrittureActiveData.persMinConsNome = s.nome
      this.scrittureActiveData.persMinConsCognome = s.cognome
      this.scrittureActiveData.persMinConsCodiceFiscale = s.codiceFiscale
      this.scrittureActiveData.persMinConsPartitaIva = s.partitaIva
      this.scrittureActiveData.persMinConsDataNascita = s.dataNascita
      this.scrittureActiveData.persMinConsNazionalita = s.nazionalita
    },
    aggiornaIntervalloScrittura: function () {
      this.scrittureFullData.forEach((obj) => {
        if (obj.intervallo1_inizio) {
          obj.inizio = obj.intervallo1_inizio
        } else {
          obj.inizio = null
        }
        if (obj.intervallo3_fine) {
          obj.fine = obj.intervallo3_fine
        } else if (obj.intervallo2_fine) {
          obj.fine = obj.intervallo2_fine
        } else if (obj.intervallo1_fine) {
          obj.fine = obj.intervallo1_fine
        } else {
          obj.fine = null
        }
      })
    },
    // calcolaPersonaleMinisteroPrev
    calcolaPersonaleMinisteroPrev: function (e) {
      console.log("Calcola Personale Ministero Preventivo")
      // data inizio
      this.scrittureActiveData.persMinPrevDataInizio = this.scrittureActiveData.intervallo1_inizio
      this.$refs.persMinPrevDataInizio.ej2Instances.value = this.scrittureActiveData.persMinPrevDataInizio
      this.$refs.persMinPrevDataInizio.dataBind()
      // data fine
      this.scrittureActiveData.persMinPrevDataFine = this.scrittureActiveData.intervallo1_fine
      this.$refs.persMinPrevDataFine.ej2Instances.value = this.scrittureActiveData.persMinPrevDataFine
      this.$refs.persMinPrevDataFine.dataBind()
      // persMinPrevGiornateLavorative
      this.scrittureActiveData.persMinPrevGiornateLavorative = this.scrittureActiveData.numGiorniScrittura
      this.$refs.persMinPrevGiornateLavorative.ej2Instances.value = this.scrittureActiveData.persMinPrevGiornateLavorative
      this.$refs.persMinPrevGiornateLavorative.dataBind()
      // persMinPrevCodiceINPS
      this.scrittureActiveData.persMinPrevCodiceINPS = this.scrittureActiveData.categoriaInps
      this.$refs.persMinPrevCodiceINPS.ej2Instances.value = this.scrittureActiveData.persMinPrevCodiceINPS
      this.$refs.persMinPrevCodiceINPS.dataBind()
      // persMinPrevRuolo
      //   recupero titolo spettacolo
      var titoloSpettacoloAttivo = ""
      this.elencoSpettacoliList.forEach((obj) => {
        if (obj.id === this.spettacoloCorrente) {
          titoloSpettacoloAttivo = obj.titolo;
        }
      })
      var ruoloAttivo = this.scrittureActiveData.ruoloGenerale + " in " + titoloSpettacoloAttivo
      if (this.scrittureActiveData.ruoloGenerale == "Cantante lirico") {
        ruoloAttivo =  ruoloAttivo + " nel ruolo di " + this.scrittureActiveData.ruolo
      }  
      this.scrittureActiveData.persMinPrevRuolo = ruoloAttivo
      this.$refs.persMinPrevRuolo.ej2Instances.value = this.scrittureActiveData.persMinPrevRuolo
      this.$refs.persMinPrevRuolo.dataBind()
      // persMinPrevTipoPersonale
      var tipoPersonaleAttivo = ""
      const tipiAmministrativo = [];
      const tipiArtistico = ["Attore", "Aiuto Regia","Coreografo", "Corpo di Ballo", "Danzatore", "Direttore d’Orchestra","Direttore di Scena", "Drammaturgo", "Figurante", "Librettista","Maestro del Coro", "Maestro di Sala", "Musicologo", "Regista", "Sarta", "Scenografo", "Tersicorei", "Voce Recitante", "Diritti Compositore", "Diritti Costumista", "Diritti Librettista", "Diritti Lighting", "Diritti Regia", "Diritti Scenografo", "Altri Diritti"];
      const tipiArtisticoLirico = ["Cantante lirico", "Coro", "Coro delle Voci Bianche"];
      const tipiProfessoreOrchestra = ["Ensemble Orchestrale", "Maestro Collaboratore", "Orchestrale"];
      const tipiTecnico = ["Aiuto Sarta", "Aiuto Scenografo", "Aiuto Trucco e Parrucco", "Attrezzista","Costumista", "Elettricista", "Fonico", "Lighting","Macchinista", "Maestro delle Luci", "Maestro del Palco", "Maestro dei Sovratitoli", "Trucco e Parrucco"];
      if (tipiAmministrativo.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "amministrativo"
      }
      else if (tipiArtistico.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "artistico"
      }
      else if (tipiArtisticoLirico.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "artisticoLirico"
      }
      else if (tipiProfessoreOrchestra.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "professoreOrchestra"
      }
      else if (tipiTecnico.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "tecnico"
      }
      this.scrittureActiveData.persMinPrevTipoPersonale = tipoPersonaleAttivo
      this.$refs.persMinPrevTipoPersonale.ej2Instances.value = this.scrittureActiveData.persMinPrevTipoPersonale
      this.$refs.persMinPrevTipoPersonale.dataBind()
      // persMinPrevTipoRapporto
      var tipoRapportoAttivo="determinato"
      if (this.scrittureActiveData.regimeFiscale == "occasionale") {
        tipoRapportoAttivo="prestazioneOccasionale" 
      }
      this.scrittureActiveData.persMinPrevTipoRapporto = tipoRapportoAttivo
      this.$refs.persMinPrevTipoRapporto.ej2Instances.value = this.scrittureActiveData.persMinPrevTipoRapporto
      this.$refs.persMinPrevTipoRapporto.dataBind()
      // persMinPrevOneri
      // TODO: Verificare se negli oneri vanno sia quelli ditta che dipendente
      if (this.scrittureActiveData.contributi_carico_ditta>0 && this.scrittureActiveData.contributi_carico_dipendente>0) {
        this.scrittureActiveData.persMinPrevOneri = this.scrittureActiveData.contributi_carico_ditta + this.scrittureActiveData.contributi_carico_dipendente
        this.$refs.persMinPrevOneri.ej2Instances.value = this.scrittureActiveData.persMinPrevOneri
        this.$refs.persMinPrevOneri.dataBind() 
      }


    },
    // calcolaPersonaleMinisteroCons
    calcolaPersonaleMinisteroCons: function (e) {
      console.log("Calcola Personale Ministero Consuntivo")
      // data inizio
      this.scrittureActiveData.persMinConsDataInizio = this.scrittureActiveData.intervallo1_inizio
      this.$refs.persMinConsDataInizio.ej2Instances.value = this.scrittureActiveData.persMinConsDataInizio
      this.$refs.persMinConsDataInizio.dataBind()
      // data fine
      this.scrittureActiveData.persMinConsDataFine = this.scrittureActiveData.intervallo1_fine
      this.$refs.persMinConsDataFine.ej2Instances.value = this.scrittureActiveData.persMinConsDataFine
      this.$refs.persMinConsDataFine.dataBind()
      // persMinConsGiornateLavorative
      this.scrittureActiveData.persMinConsGiornateLavorative = this.scrittureActiveData.numGiorniScrittura
      this.$refs.persMinConsGiornateLavorative.ej2Instances.value = this.scrittureActiveData.persMinConsGiornateLavorative
      this.$refs.persMinConsGiornateLavorative.dataBind()
      // persMinConsCodiceINPS
      this.scrittureActiveData.persMinConsCodiceINPS = this.scrittureActiveData.categoriaInps
      this.$refs.persMinConsCodiceINPS.ej2Instances.value = this.scrittureActiveData.persMinConsCodiceINPS
      this.$refs.persMinConsCodiceINPS.dataBind()
      // persMinConsRuolo
      //   recupero titolo spettacolo
      var titoloSpettacoloAttivo = ""
      this.elencoSpettacoliList.forEach((obj) => {
        if (obj.id === this.spettacoloCorrente) {
          titoloSpettacoloAttivo = obj.titolo;
        }
      })
      var ruoloAttivo = this.scrittureActiveData.ruoloGenerale + " in " + titoloSpettacoloAttivo
      if (this.scrittureActiveData.ruoloGenerale == "Cantante lirico") {
        ruoloAttivo =  ruoloAttivo + " nel ruolo di " + this.scrittureActiveData.ruolo
      }  
      this.scrittureActiveData.persMinConsRuolo = ruoloAttivo
      this.$refs.persMinConsRuolo.ej2Instances.value = this.scrittureActiveData.persMinConsRuolo
      this.$refs.persMinConsRuolo.dataBind()
      // persMinConsTipoPersonale
      var tipoPersonaleAttivo = ""
      const tipiAmministrativo = [];
      const tipiArtistico = ["Attore", "Aiuto Regia","Coreografo", "Corpo di Ballo", "Danzatore", "Direttore d’Orchestra","Direttore di Scena", "Drammaturgo", "Figurante", "Librettista","Maestro del Coro", "Maestro di Sala", "Musicologo", "Regista", "Sarta", "Scenografo", "Tersicorei", "Voce Recitante", "Diritti Compositore", "Diritti Costumista", "Diritti Librettista", "Diritti Lighting", "Diritti Regia", "Diritti Scenografo", "Altri Diritti"];
      const tipiArtisticoLirico = ["Cantante lirico", "Coro", "Coro delle Voci Bianche"];
      const tipiProfessoreOrchestra = ["Ensemble Orchestrale", "Maestro Collaboratore", "Orchestrale"];
      const tipiTecnico = ["Aiuto Sarta", "Aiuto Scenografo", "Aiuto Trucco e Parrucco", "Attrezzista","Costumista", "Elettricista", "Fonico", "Lighting","Macchinista", "Maestro delle Luci", "Maestro del Palco", "Maestro dei Sovratitoli", "Trucco e Parrucco"];
      if (tipiAmministrativo.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "amministrativo"
      }
      else if (tipiArtistico.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "artistico"
      }
      else if (tipiArtisticoLirico.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "artisticoLirico"
      }
      else if (tipiProfessoreOrchestra.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "professoreOrchestra"
      }
      else if (tipiTecnico.includes(this.scrittureActiveData.ruoloGenerale)) {
        tipoPersonaleAttivo = "tecnico"
      }
      this.scrittureActiveData.persMinConsTipoPersonale = tipoPersonaleAttivo
      this.$refs.persMinConsTipoPersonale.ej2Instances.value = this.scrittureActiveData.persMinConsTipoPersonale
      this.$refs.persMinConsTipoPersonale.dataBind()
      // persMinConsTipoRapporto
      var tipoRapportoAttivo="determinato"
      if (this.scrittureActiveData.regimeFiscale == "occasionale") {
        tipoRapportoAttivo="prestazioneOccasionale" 
      }
      this.scrittureActiveData.persMinConsTipoRapporto = tipoRapportoAttivo
      this.$refs.persMinConsTipoRapporto.ej2Instances.value = this.scrittureActiveData.persMinConsTipoRapporto
      this.$refs.persMinConsTipoRapporto.dataBind()
      // persMinConsOneri
      // TODO: Verificare se negli oneri vanno sia quelli ditta che dipendente
      if (this.scrittureActiveData.contributi_carico_ditta>0 && this.scrittureActiveData.contributi_carico_dipendente>0) {
        this.scrittureActiveData.persMinConsOneri = this.scrittureActiveData.contributi_carico_ditta + this.scrittureActiveData.contributi_carico_dipendente
        this.$refs.persMinConsOneri.ej2Instances.value = this.scrittureActiveData.persMinConsOneri
        this.$refs.persMinConsOneri.dataBind() 
      }
    },
    spettacoloFiltering: function (e) {
      var searchData = this.elencoSpettacoliList;
      var query = this.querySpettacoli.clone();
      if (e.text != "") {
        query = query.where("titolo", "contains", e.text, true);
      }
      // console.log(query);
      // console.log(query.queries);
      e.updateData(searchData, query);
    },
    // per elenco soggetti: filtra la digitazione per cognome
    soggettoFiltering: function (e) {
      var searchData = this.elencoSoggFiltratiList;
      var query = new Query();
      // puoi usare contains, startsWith, or endsWith
      query = e.text != "" ? query.where("denominazione", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    // per categoriaInps
    categoriaInpsFiltering: function (e) {
      var searchData = this.categoriaInpsList;
      var query = new Query();
      //frame the query based on search string with filter type.
      query =
        e.text != "" ? query.where("label", "contains", e.text, true) : query; // puoi usare contains, startsWith, or endsWith
      //pass the filter data source, filter query to updateData method.
      e.updateData(searchData, query);
    },
    inQualitaFiltering: function (e) {
      var searchData = this.inQualitaList;
      var query = new Query();
      query =
        e.text != "" ? query.where("label", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    ruoloFiltering: function (e) {
      var searchData = this.ruoloList;
      var query = new Query();
      query =
        e.text != "" ? query.where("label", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    qualificaFiltering: function (e) {
      var searchData = this.qualificaList;
      var query = new Query();
      query =
        e.text != "" ? query.where("label", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    mansioneFiltering: function (e) {
      var searchData = this.mansioneList;
      var query = new Query();
      query =
        e.text != "" ? query.where("label", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    dirittiFiltering: function (e) {
      var searchData = this.tipologiaDirittiList;
      var query = new Query();
      query =
        e.text != "" ? query.where("label", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    aggiornaCostoAziendaTotale: function (e) {
      // calcolo ENPALS
      // sconosciuta o null (trattato come tabC)
      if (this.scrittureActiveData.tipologia_contributo_soggetto == "sconosciuta" || this.scrittureActiveData.tipologia_contributo_soggetto == null) {
        // EnpalsCaricoDitta
        this.scrittureActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) * 23.81 * 0.01)
        // EnpalsFPL, EnpalsContrSolid
        this.scrittureActiveData.percEnFPL = 9.19
        this.scrittureActiveData.impEnpalsFPl = Math.round(this.scrittureActiveData.compenso_totale)
        this.scrittureActiveData.EnpalsFPL = this.roundNumber(this.scrittureActiveData.impEnpalsFPl * this.scrittureActiveData.percEnFPL * 0.01)
        this.scrittureActiveData.impEnpalsSolid = 0
        this.scrittureActiveData.percEnSol = 0
        this.scrittureActiveData.EnpalsContrSolid = 0;
        // EnpalsContrAgg
        if (Math.round(this.scrittureActiveData.compenso_totale) > (55448.00 / 12.00)) {
          this.scrittureActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) - (55448.00/12.00))
          this.scrittureActiveData.percEnAgg = 1.0
          this.scrittureActiveData.EnpalsContrAgg = this.roundNumber(this.scrittureActiveData.impEnpalsAgg * this.scrittureActiveData.percEnAgg * 0.01)
        }
        else {
          this.scrittureActiveData.impEnpalsAgg = 0
          this.scrittureActiveData.percEnAgg = 0
          this.scrittureActiveData.EnpalsContrAgg = 0
        }
      }
      // gestione "tabD"
      else if (this.scrittureActiveData.tipologia_contributo_soggetto == "tabD") {
        // EnpalsCaricoDitta
        this.scrittureActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) * 23.81 * 0.01)
        // EnpalsFPL, EnpalsContrSolid
        if (this.scrittureActiveData.retribGiornaliera < 872.01) {
          this.scrittureActiveData.percEnFPL = 9.19
          this.scrittureActiveData.impEnpalsFPl = Math.round(this.scrittureActiveData.compenso_totale)
          this.scrittureActiveData.EnpalsFPL = this.roundNumber(this.scrittureActiveData.impEnpalsFPl * this.scrittureActiveData.percEnFPL * 0.01)
        }
        else if (this.scrittureActiveData.retribGiornaliera < 1744.01) {
          this.scrittureActiveData.percEnFPL = 9.19
          this.scrittureActiveData.percEnSol = 2.5
          this.scrittureActiveData.impEnpalsFPl = this.roundNumber(this.scrittureActiveData.numGiorniMeseRetribuiti * 872.00)
          this.scrittureActiveData.EnpalsFPL = this.roundNumber(this.scrittureActiveData.impEnpalsFPl * this.scrittureActiveData.percEnFPL * 0.01)
          this.scrittureActiveData.impEnpalsSolid = Math.round(this.scrittureActiveData.compenso_totale) - this.scrittureActiveData.impEnpalsFPl
          this.scrittureActiveData.EnpalsContrSolid = this.roundNumber(this.scrittureActiveData.impEnpalsSolid * this.scrittureActiveData.percEnSol * 0.01)
        }
        else if (this.scrittureActiveData.retribGiornaliera < 4360.01) {
          this.scrittureActiveData.percEnFPL = 9.19
          this.scrittureActiveData.percEnSol = 2.5
          this.scrittureActiveData.impEnpalsFPl = this.roundNumber(this.scrittureActiveData.numGiorniMeseRetribuiti * 1744.00)
          this.scrittureActiveData.EnpalsFPL = this.roundNumber(this.scrittureActiveData.impEnpalsFPl * this.scrittureActiveData.percEnFPL * 0.01)
          this.scrittureActiveData.impEnpalsSolid = Math.round(this.scrittureActiveData.compenso_totale) - this.scrittureActiveData.impEnpalsFPl
          this.scrittureActiveData.EnpalsContrSolid = this.roundNumber(this.scrittureActiveData.impEnpalsSolid * this.scrittureActiveData.percEnSol * 0.01)
        }
        // EnpalsContrAgg
        if (this.scrittureActiveData.retribGiornaliera > 176.00) {
          this.scrittureActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) - this.scrittureActiveData.numGiorniMeseRetribuiti * 176)
          this.scrittureActiveData.percEnAgg = 1.0
          this.scrittureActiveData.EnpalsContrAgg = this.roundNumber(this.scrittureActiveData.impEnpalsAgg * this.scrittureActiveData.percEnAgg * 0.01)
        }
        else {
          this.scrittureActiveData.impEnpalsAgg = 0
          this.scrittureActiveData.percEnAgg = 0
          this.scrittureActiveData.EnpalsContrAgg = 0
        }
      }
      else if (this.scrittureActiveData.tipologia_contributo_soggetto == "tabC") {
        // EnpalsCaricoDitta
        this.scrittureActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) * 23.81 * 0.01)
        // EnpalsFPL, EnpalsContrSolid
        this.scrittureActiveData.percEnFPL = 9.19
        this.scrittureActiveData.impEnpalsFPl = Math.round(this.scrittureActiveData.compenso_totale)
        this.scrittureActiveData.EnpalsFPL = this.roundNumber(this.scrittureActiveData.impEnpalsFPl * this.scrittureActiveData.percEnFPL * 0.01)
        this.scrittureActiveData.impEnpalsSolid = 0
        this.scrittureActiveData.percEnSol = 0
        this.scrittureActiveData.EnpalsContrSolid = 0;
        // EnpalsContrAgg
        if (Math.round(this.scrittureActiveData.compenso_totale) > (55448.00 / 12.00)) {
          this.scrittureActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) - (55448.00/12.00))
          this.scrittureActiveData.percEnAgg = 1.0
          this.scrittureActiveData.EnpalsContrAgg = this.roundNumber(this.scrittureActiveData.impEnpalsAgg * this.scrittureActiveData.percEnAgg * 0.01)
        }
        else {
          this.scrittureActiveData.impEnpalsAgg = 0
          this.scrittureActiveData.percEnAgg = 0
          this.scrittureActiveData.EnpalsContrAgg = 0
        }
      }
      else if (this.scrittureActiveData.tipologia_contributo_soggetto == "tabG") {
        // EnpalsCaricoDitta
        this.scrittureActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) * 23.81 * 0.01)
        // EnpalsFPL, EnpalsContrSolid
        this.scrittureActiveData.percEnFPL = 9.19
        this.scrittureActiveData.impEnpalsFPl = Math.round(this.scrittureActiveData.compenso_totale)
        this.scrittureActiveData.EnpalsFPL = this.roundNumber(this.scrittureActiveData.impEnpalsFPl * this.scrittureActiveData.percEnFPL * 0.01)
        this.scrittureActiveData.impEnpalsSolid = 0
        this.scrittureActiveData.percEnSol = 0
        this.scrittureActiveData.EnpalsContrSolid = 0;
        // EnpalsContrAgg
        if (Math.round(this.scrittureActiveData.compenso_totale) > (55448.00 / 12.00)) {
          this.scrittureActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) - (55448.00/12.00))
          this.scrittureActiveData.percEnAgg = 1.0
          this.scrittureActiveData.EnpalsContrAgg = this.roundNumber(this.scrittureActiveData.impEnpalsAgg * this.scrittureActiveData.percEnAgg * 0.01)
        }
        else {
          this.scrittureActiveData.impEnpalsAgg = 0
          this.scrittureActiveData.percEnAgg = 0
          this.scrittureActiveData.EnpalsContrAgg = 0
        }
      }
      else if (this.scrittureActiveData.tipologia_contributo_soggetto == "tabR") {
        // EnpalsCaricoDitta
        this.scrittureActiveData.EnpalsCaricoDitta = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) * 25.81 * 0.01)
        // EnpalsFPL, EnpalsContrSolid
        this.scrittureActiveData.percEnFPL = 9.89
        this.scrittureActiveData.impEnpalsFPl = Math.round(this.scrittureActiveData.compenso_totale)
        this.scrittureActiveData.EnpalsFPL = this.roundNumber(this.scrittureActiveData.impEnpalsFPl * this.scrittureActiveData.percEnFPL * 0.01)
        this.scrittureActiveData.impEnpalsSolid = 0
        this.scrittureActiveData.percEnSol = 0
        this.scrittureActiveData.EnpalsContrSolid = 0;
        // EnpalsContrAgg
        if (Math.round(this.scrittureActiveData.compenso_totale) > (55448.00 / 12.00)) {
          this.scrittureActiveData.impEnpalsAgg = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) - (55448.00/12.00))
          this.scrittureActiveData.percEnAgg = 1.0
          this.scrittureActiveData.EnpalsContrAgg = this.roundNumber(this.scrittureActiveData.impEnpalsAgg * this.scrittureActiveData.percEnAgg * 0.01)
        }
        else {
          this.scrittureActiveData.impEnpalsAgg = 0
          this.scrittureActiveData.percEnAgg = 0
          this.scrittureActiveData.EnpalsContrAgg = 0
        }
      } else {
        // in caso sia sconosciuta
        this.scrittureActiveData.EnpalsCaricoDitta = 0
        this.scrittureActiveData.percEnFPL = 0
        this.scrittureActiveData.impEnpalsFPl = 0
        this.scrittureActiveData.EnpalsFPL = 0
        this.scrittureActiveData.impEnpalsSolid = 0
        this.scrittureActiveData.percEnSol = 0
        this.scrittureActiveData.EnpalsContrSolid = 0
        this.scrittureActiveData.impEnpalsAgg = 0
        this.scrittureActiveData.percEnAgg = 0
        this.scrittureActiveData.EnpalsContrAgg = 0

      }

      // Calcolo i totali
      const tipologie_contributi_primo_blocco = ["3", "4", "5", "6"];

      // calcolo voci MalattiaEMatern, Alas, Inail
      const totMalattMaternAlasInail = this.roundNumber(Math.round(this.scrittureActiveData.compenso_totale) * (2.22+1.06+2.64) * 0.01)
      if (tipologie_contributi_primo_blocco.includes(this.scrittureActiveData.tipologia)) {
        this.scrittureActiveData.contributi_carico_ditta = this.roundNumber(this.scrittureActiveData.EnpalsCaricoDitta + this.scrittureActiveData.EnpalsContrSolid+ totMalattMaternAlasInail)
        this.scrittureActiveData.contributi_carico_dipendente = this.roundNumber(this.scrittureActiveData.EnpalsFPL + this.scrittureActiveData.EnpalsContrSolid + this.scrittureActiveData.EnpalsContrAgg)
        this.scrittureActiveData.costo_azienda_totale = this.roundNumber(this.scrittureActiveData.compenso_totale + this.scrittureActiveData.contributi_carico_ditta)
        console.log("Enpals Carico ditta")
        console.log(this.scrittureActiveData.EnpalsCaricoDitta)
        console.log("Enpals Contr solid")
        console.log(this.scrittureActiveData.EnpalsContrSolid)
        console.log("compenso_totale")
        console.log(this.scrittureActiveData.compenso_totale)
        console.log("contributi_carico_ditta")
        console.log(this.scrittureActiveData.contributi_carico_ditta)
        console.log("contributi_carico_dipendente")
        console.log(this.scrittureActiveData.contributi_carico_dipendente)
        console.log("costo_azienda_totale")
        console.log(this.scrittureActiveData.costo_azienda_totale)
      }
      // else {
      //   this.scrittureActiveData.contributi_carico_ditta = 0
      //   this.scrittureActiveData.contributi_carico_dipendente = 0
      //   this.scrittureActiveData.costo_azienda_totale = this.roundNumber(this.scrittureActiveData.compenso_totale)
      //   console.log("contributi_carico_ditta")
      //   console.log(this.scrittureActiveData.contributi_carico_ditta)
      //   console.log("contributi_carico_dipendente")
      //   console.log(this.scrittureActiveData.contributi_carico_dipendente)
      //   console.log("costo_azienda_totale")
      //   console.log(this.scrittureActiveData.costo_azienda_totale)
      // }
      // TODO (SIMO 11/12): 
      // Al momento di applica ai contratti 3-6
      // Contratti 1-2: come valorizzare costo_azienda_totale, contributi_carico_ditta, contributi_carico_dipendente?
      // Contratti 7: come valorizzare costo_azienda_totale, contributi_carico_ditta, contributi_carico_dipendente?

      // valorizzazione oneriPreventivo
      // this.oneriPreventivoActiveData.costo_retribuzione = this.scrittureActiveData.compenso_totale
      // this.oneriPreventivoActiveData.costo_contributivo = this.scrittureActiveData.compenso_totale
      // this.oneriPreventivoActiveData.costo_inail = this.scrittureActiveData.compenso_totale
      // this.oneriPreventivoActiveData.oneri_carico_ditta = this.scrittureActiveData.compenso_totale
    },
    onDelayPagamentoChange: function() {
      console.log("NUOVO VALORE DELAY PAGAMENTO")
      let delay = this.$refs.delayPagamento.ej2Instances.value
      let dataScadenzaPagamentoAttuale = this.$refs.dataScadenzaPagamento.ej2Instances.value
      if (dataScadenzaPagamentoAttuale == null) {
        var p = new Date()
        p.setHours(0, 30, 0)
      } else {
        var p = new Date(this.$refs.dataScadenzaPagamento.ej2Instances.value)
      }
      console.log(this.$refs.dataScadenzaPagamento.ej2Instances.value)
      console.log("data scadenza pagamento attuale")
      console.log(p)
      if (oldDelay != null) {
        p.setDate(p.getDate() - oldDelay)
      }
      p.setDate(p.getDate() + delay)
      oldDelay = delay
      this.scrittureActiveData.dataScadenzaPagamento = p
      console.log("data scadenza pagamento aggiornata")
      console.log(p)
    },

    // aggiorna onSoggettoChange
    async onSoggettoChange() {
      if (this.dialogA1.isVisible == true) {
        let i;
        try {
          const r = await useJwt.get(apiSoggettiUrl + '/' + this.scrittureActiveData.soggetto).then((d) => {
            // aggiorna elencoSpettacoliList
            i = this.elencoSoggFiltratiList.findIndex((x) => x.id === this.scrittureActiveData.soggetto)
            if (i >= 0) {
              this.elencoSoggFiltratiList[i] = d.data
              this.elencoSoggFiltratiList = [ ...this.elencoSoggFiltratiList ]
              console.log("Variazione soggetto: recupero info Enpals e Regime Fiscale");
              this.scrittureActiveData.tipologia_contributo_soggetto = this.elencoSoggFiltratiList[i].ENPALSCategoria;
              this.scrittureActiveData.regimeFiscale = this.elencoSoggFiltratiList[i].regimeFiscale;
              this.scrittureActiveData.esenzione = this.elencoSoggFiltratiList[i].esenzione;
              // aggiorna info ministero
              this.aggiornaInfoMinistero(this.elencoSoggFiltratiList[i])
              console.log(this.scrittureActiveData.tipologia_contributo_soggetto);
            }
          })
        } catch (err) {
          console.log("Errore nel recupero info soggetto");
          console.log(err);
        }
      }
    },
    // aggiorna on_compenso_lordo_giornaliero_change
    on_compenso_lordo_giornaliero_change: function () {
      if (this.dialogA1.isVisible == true) {
        console.log("on_compenso_lordo_giornaliero_change");
        this.scrittureActiveData.compenso_lordo_giornaliero_scritto = null;
        if (
          this.scrittureActiveData.tipologia == "3" ||
          this.scrittureActiveData.tipologia == "4"
        ) {
          // Autonomi Tecnici/Artisti Compenso Giornaliero
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_giornaliero *
          this.scrittureActiveData.numGiorniScrittura;
          this.scrittureActiveData.retribGiornaliera =
            this.scrittureActiveData.compenso_lordo_giornaliero;
          this.eseguiTestRetribuzioneGiornaliera();
          this.aggiornaCostoAziendaTotale();
        }
      }
    },
    // aggiorna on_compenso_lordo_complessivo_change
    on_compenso_lordo_complessivo_change: function () {
      if (this.dialogA1.isVisible == true) {
        console.log("on_compenso_lordo_complessivo_change");
        console.log(this.scrittureActiveData.compenso_lordo_complessivo);
        this.scrittureActiveData.compenso_lordo_complessivo_scritto = null;
        if (this.scrittureActiveData.tipologia == "1") {
          // Subordinati tecnici a prestazione
          this.scrittureActiveData.contributi_carico_ditta =
            this.scrittureActiveData.compenso_lordo_complessivo * 0.3588;
          this.scrittureActiveData.contributi_carico_dipendente =
            this.scrittureActiveData.compenso_lordo_complessivo * 0.0919;
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo + this.scrittureActiveData.contributi_carico_ditta;
          this.scrittureActiveData.costo_azienda_totale =
            this.scrittureActiveData.compenso_lordo_complessivo + this.scrittureActiveData.contributi_carico_ditta;
        }
        if (this.scrittureActiveData.tipologia == "2") {
          // Subordinati tecnici a prestazione
          this.scrittureActiveData.contributi_carico_ditta =
            this.scrittureActiveData.compenso_lordo_complessivo * 0.3588;
          this.scrittureActiveData.contributi_carico_dipendente =
            this.scrittureActiveData.compenso_lordo_complessivo * 0.0919;
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo + this.scrittureActiveData.contributi_carico_ditta;
          this.scrittureActiveData.costo_azienda_totale =
            this.scrittureActiveData.compenso_lordo_complessivo + this.scrittureActiveData.contributi_carico_ditta;
        }
        if (this.scrittureActiveData.tipologia == "5") {
          // Autonomi Tecnici Compenso Complessivo
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
          if (this.scrittureActiveData.numGiorniScrittura > 0) {
            this.scrittureActiveData.retribGiornaliera =
              this.scrittureActiveData.compenso_lordo_complessivo /
            this.scrittureActiveData.numGiorniScrittura;
            this.eseguiTestRetribuzioneGiornaliera();
          }
          this.aggiornaCostoAziendaTotale();
        }
        if (this.scrittureActiveData.tipologia == "7") {
          // diritti
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
          this.scrittureActiveData.costo_azienda_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
        }
        if (this.scrittureActiveData.tipologia == "8") {
          // coro
          console.log("coro");
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
          this.scrittureActiveData.costo_azienda_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
          console.log(this.scrittureActiveData.costo_azienda_totale)
        }
        if (this.scrittureActiveData.tipologia == "9") {
          // orchestra
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
          this.scrittureActiveData.costo_azienda_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
        }
        if (this.scrittureActiveData.tipologia == "10") {
          // corpo di ballo
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
          this.scrittureActiveData.costo_azienda_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
        }
        if (this.scrittureActiveData.tipologia == "11") {
          // dipendenti interni
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
          this.scrittureActiveData.costo_azienda_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
        }
        if (this.scrittureActiveData.tipologia == "12") {
          // compagnie ospiti
          this.scrittureActiveData.compenso_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
          this.scrittureActiveData.costo_azienda_totale =
            this.scrittureActiveData.compenso_lordo_complessivo;
        }
        if (this.scrittureActiveData.tipologia == "13") {
          console.log("relatore - conferenziere");
          this.scrittureActiveData.compenso_totale = this.scrittureActiveData.compenso_lordo_complessivo;
          this.scrittureActiveData.costo_azienda_totale = this.scrittureActiveData.compenso_lordo_complessivo;
          console.log(this.scrittureActiveData.costo_azienda_totale)
        }
        if (this.scrittureActiveData.tipologia == "14") {
          console.log("compagnie ospiti");
          this.scrittureActiveData.compenso_totale = this.scrittureActiveData.compenso_lordo_complessivo;
          this.scrittureActiveData.costo_azienda_totale = this.scrittureActiveData.compenso_lordo_complessivo;
          console.log(this.scrittureActiveData.costo_azienda_totale)
        }

      }
    },
    // aggiorna on_importo_recita_change
    on_importo_recita_change: function () {
      if (this.dialogA1.isVisible == true) {
        console.log("on_importo_recita_change");
        this.scrittureActiveData.compenso_lordo_complessivo =
          this.scrittureActiveData.importo_recita1 +
          this.scrittureActiveData.importo_recita2 +
          this.scrittureActiveData.importo_recita3 +
          this.scrittureActiveData.importo_recita4 +
          this.scrittureActiveData.importo_recita5;
        this.scrittureActiveData.compenso_lordo_complessivo_scritto = null;
        this.scrittureActiveData.compenso_totale =
          this.scrittureActiveData.compenso_lordo_complessivo;
        if (this.scrittureActiveData.numGiorniScrittura > 0) {
          this.scrittureActiveData.retribGiornaliera =
            this.scrittureActiveData.compenso_lordo_complessivo /
          this.scrittureActiveData.numGiorniScrittura;
          this.eseguiTestRetribuzioneGiornaliera();
        }
        this.aggiornaCostoAziendaTotale();
      }
    },
    // aggiorna on_dataContratto_change
    on_dataContratto_change: function () {
      if (this.dialogA1.isVisible == true) {
        // rispristino stati del contratto (TODO: gestire caso in cui bloccoModifica e' attivo)
        this.scrittureActiveData.statoContratto = "Da Generare";
      }
    },
    // aggiorna onnumGiorniScritturaChange
    onnumGiorniScritturaChange: function () {
      if (
        this.scrittureActiveData.tipologia == "3" ||
        this.scrittureActiveData.tipologia == "4"
      ) {
        // Autonomi Tecnici/Artisti Compenso Giornaliero
        this.scrittureActiveData.compenso_totale =
          this.scrittureActiveData.compenso_lordo_giornaliero *
        this.scrittureActiveData.numGiorniScrittura;
        this.aggiornaCostoAziendaTotale();
      } else if (
        this.scrittureActiveData.tipologia == "5" ||
        this.scrittureActiveData.tipologia == "6"
      ) {
        // Autonomi Artisti Compenso Complessivo
        if (this.scrittureActiveData.numGiorniScrittura > 0) {
          this.scrittureActiveData.retribGiornaliera =
            this.scrittureActiveData.compenso_totale /
          this.scrittureActiveData.numGiorniScrittura;
          this.eseguiTestRetribuzioneGiornaliera();
        }
      }
    },
    // aggiorna onRecitaChange
    onRecitaChange: function () {
      if (this.dialogA1.isVisible == true) {
        console.log("Aggiorno numero giorni di recite");
        let cont = 0;
        if (this.scrittureActiveData.recita1 != null) cont++;
        if (this.scrittureActiveData.recita2 != null) cont++;
        if (this.scrittureActiveData.recita3 != null) cont++;
        if (this.scrittureActiveData.recita4 != null) cont++;
        if (this.scrittureActiveData.recita5 != null) cont++;
        console.log(cont);
        this.scrittureActiveData.numGiorniRecite = cont;
      }
    },
    // aggiorna quando cambia il tipo contributo soggetto
    on_tipologia_contributo_soggetto_change: function () {
      this.aggiornaCostoAziendaTotale();
      this.eseguiTestRetribuzioneGiornaliera(); // al momento non dipende da tipologia_contributo_soggetto ma potrebbe
    },
    // esegue il test di retribuzione giornaliera
    eseguiTestRetribuzioneGiornaliera: function () {
      const minimoGiornaliero = 49.91; // <------------------------- Valore minimo di retribuzione giornaliera 2022
      if (this.scrittureActiveData.retribGiornaliera > minimoGiornaliero) {
        this.scrittureActiveData.testRetribGiornaliera = "Ok";
      } else {
        this.scrittureActiveData.testRetribGiornaliera = "KO";
      }
    },
    // aggiorna on_tipologia_diritti_change
    on_tipologia_diritti_change: function () {
      this.scrittureActiveData.ruoloGenerale =
        this.scrittureActiveData.tipologia_diritti;
      if (this.scrittureActiveData.tipologia_diritti == "Diritti Compositore") {
        this.scrittureActiveData.causale_diritti = "di Composizione";
      } else if (
        this.scrittureActiveData.tipologia_diritti == "Diritti Costumista"
      ) {
        this.scrittureActiveData.causale_diritti = "di Costumi";
      } else if (
        this.scrittureActiveData.tipologia_diritti == "Diritti Librettista"
      ) {
        this.scrittureActiveData.causale_diritti = "di Libretto";
      } else if (
        this.scrittureActiveData.tipologia_diritti == "Diritti Lighting"
      ) {
        this.scrittureActiveData.causale_diritti = "di Luci";
      } else if (
        this.scrittureActiveData.tipologia_diritti == "Diritti Regia"
      ) {
        this.scrittureActiveData.causale_diritti = "di Regia";
      } else if (
        this.scrittureActiveData.tipologia_diritti == "Diritti Scenografo"
      ) {
        this.scrittureActiveData.causale_diritti = "di Scenografia";
      }
    },
    // aggiorna on_diaria_change
    onDiariaChange: function () {
      if (this.dialogA1.isVisible == true) {
        console.log("onDiariaChange");
        var s = this.scrittureActiveData
        var totDiaria = 0
        var totPernotto = 0
        if (s.giorniDiaria != null && s.importoSingolaDiaria != null) {
          totDiaria = s.giorniDiaria * s.importoSingolaDiaria;
        }
        if (s.numeroPernotti != null && s.importoSingoloPernotto != null) {
          totPernotto = s.numeroPernotti * s.importoSingoloPernotto
        }
        s.importoTotaleDiaria = totDiaria + totPernotto
        s.contributiDiaria = s.importoTotaleDiaria * 0.38 * 0.4
        // Aggiorno totaleDiariaRimborsi
        this.aggiornaTotaleDiariaRimborsi();
      }
    },
    // aggiornaTotaleDiariaRimborsi
    aggiornaTotaleDiariaRimborsi: function () {
      var s = this.scrittureActiveData
      if (this.dialogA1.isVisible == true) {
        console.log("aggiornaTotaleDiariaRimborsi");
        s.totaleDiariaRimborsi = s.importoTotaleDiaria + s.contributiDiaria + s.rimborsoKmTotale + s.speseAlloggio + s.rimborsoSpese + s.talatoPaypal;
      }
    },
    // per dropdownlist combinate
    onStagioneChange: function (e) {
      this.querySpettacoli = new Query().where(
        "stagione",
        "equal",
        this.$refs.dropStagioni.ej2Instances.value
      );
      this.dropSpettacoliEnabled = true;
      this.scrittureFullData = [];
      this.downloadxlsEnabled = true;
      // reset campo spettacolo
      this.$refs.dropSpettacoli.ej2Instances.value = null
      this.$refs.dropSpettacoli.ej2Instances.dataBind()
    },
    onSpettacoloChange: function(e) {
      // abilito gridA
      this.$refs.gridA.$el.classList.remove("disablegrid");
      document.getElementById("GridParent").classList.remove("wrapper");

      const obj = this.elencoSpettacoliList.find((obj) => {
        return obj.id ===this.spettacoloCorrente 
      });
      if (obj !== undefined) {
        this.spettacoloCorrenteHasMinistero = obj.ministero;
      }
      console.log(this.spettacoloCorrente)
      console.log(this.spettacoloCorrenteHasMinistero)
      // recupero elenco scritture dal backend
      if (localStorage.getItem("userData") !== null) {
        this.loading = true;
        console.log("Recupero elenco scritture dal backend");
        const datiDaInviare = {
          stagione: this.stagioneCorrente, // la stagione non serve, lo spettacolo ha già il riferimento alla stagione
          spettacolo: this.spettacoloCorrente,
        };
        if (datiDaInviare.spettacolo === null) {
          console.log("Spettacolo non ancora selezionato");
        } else {
          useJwt.post(apiScritturaRicercaUrl, datiDaInviare).then((d) => {
            // gestione risposta
            this.scrittureFullData = d.data;
            // console.log("Elenco scritture collegate");
            // console.log(this.scrittureFullData);
            this.aggiornaIntervalloScrittura()
            this.loading = false;
          });

          useJwt.post(apiReciteSpettacoloUrl, datiDaInviare).then((d) => {
            // gestione risposta
            this.dettReciteList = d.data;
            this.dettReciteList.forEach((obj) => {
              const date = new Date(obj.data);
              obj.dataStringa = date.toLocaleDateString("it-IT", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              });
              //console.log(obj.dataStringa)
              const tmpOrario = obj.orario.split("T")[1].split(".")[0];
              //const ora = Number(tmpOrario.split(':')[0]) + 1 // corregge ora sommando 1 a causa della gestione timezone
              const ora = Number(tmpOrario.split(":")[0]) + 0; // corregge ora sommando 1 a causa della gestione timezone
              const minuti = tmpOrario.split(":")[1];
              obj.orarioStringa = ora.toString() + ":" + minuti;
              obj.dataRiepilogo = obj.dataStringa + " ore " + obj.orarioStringa;
              // console.log("obj.dataRiepilogo");
              // console.log(obj.dataRiepilogo);
              // console.log(obj.orarioStringa)
              // console.log(obj.dataStringa)
            });
            console.log("DETTAGLIO RECITE");
            console.log(this.dettReciteList);
          });
        }
      } else {
        console.log("Non trovo UserData, prova ancora");
      }
    },

    onTipologiaScritturaChange: function (e) {
      //this.aggiornaCostoAziendaTotale()
      if (this.scrittureActiveData.tipologia == "7") {
        // diritti
        this.scrittureActiveData.ruoloGenerale = "diritti";
        console.log(this.scrittureActiveData.ruoloGenerale);
      }
      else if (this.scrittureActiveData.tipologia == "8") {
        // coro
        this.scrittureActiveData.ruoloGenerale = "Coro";
        console.log(this.scrittureActiveData.ruoloGenerale);
      }
      else if (this.scrittureActiveData.tipologia == "9") {
        // orchestra
        this.scrittureActiveData.ruoloGenerale = "Orchestra";
        console.log(this.scrittureActiveData.ruoloGenerale);
      }
      else if (this.scrittureActiveData.tipologia == "10") {
        // corpo di ballo
        this.scrittureActiveData.ruoloGenerale = "Corpo di Ballo";
        console.log(this.scrittureActiveData.ruoloGenerale);
      }
      else if (this.scrittureActiveData.tipologia == "11") {
        // dipendenti interni
        this.scrittureActiveData.ruoloGenerale = "Dipendenti Interni";
        console.log(this.scrittureActiveData.ruoloGenerale);
      }
      else if (this.scrittureActiveData.tipologia == "12") {
        this.scrittureActiveData.ruoloGenerale = "Compagnie Ospiti";
        console.log(this.scrittureActiveData.ruoloGenerale);
      }
      else if (this.scrittureActiveData.tipologia == "13") {
        this.scrittureActiveData.ruoloGenerale = "Relatori - Conferenzieri";
        console.log(this.scrittureActiveData.ruoloGenerale);
      }
      else if (this.scrittureActiveData.tipologia == "14") {
        this.scrittureActiveData.ruoloGenerale = "Compagnie Ospiti";
        console.log(this.scrittureActiveData.ruoloGenerale);
      }

      // nasconde ruolo
      this.showRuolo = false;
    },
    // Troncatura decimali scrittura
    troncaDecimaliScrittura() {
      // troncatura decimali numerici delle valute
      console.log("troncatura decimali numerici delle valute");
      if (this.scrittureActiveData.compenso_lordo_giornaliero != null) {
        this.scrittureActiveData.compenso_lordo_giornaliero = Number(
          this.scrittureActiveData.compenso_lordo_giornaliero.toFixed(2)
        );
      }
      if (this.scrittureActiveData.compenso_lordo_complessivo != null) {
        this.scrittureActiveData.compenso_lordo_complessivo = Number(
          this.scrittureActiveData.compenso_lordo_complessivo.toFixed(2)
        );
      }
      if (this.scrittureActiveData.all1_compenso_giornaliero != null) {
        this.scrittureActiveData.all1_compenso_giornaliero = Number(
          this.scrittureActiveData.all1_compenso_giornaliero.toFixed(2)
        );
      }
      if (this.scrittureActiveData.compenso_totale != null) {
        this.scrittureActiveData.compenso_totale = Number(
          this.scrittureActiveData.compenso_totale.toFixed(2)
        );
      }
      if (this.scrittureActiveData.costo_azienda_totale != null) {
        this.scrittureActiveData.costo_azienda_totale = Number(
          this.scrittureActiveData.costo_azienda_totale.toFixed(2)
        );
      }
      if (this.scrittureActiveData.costo_azienda_giornaliero != null) {
        this.scrittureActiveData.costo_azienda_giornaliero = Number(
          this.scrittureActiveData.costo_azienda_giornaliero.toFixed(2)
        );
      }
      if (this.scrittureActiveData.retribGiornaliera != null) {
        this.scrittureActiveData.retribGiornaliera = Number(
          this.scrittureActiveData.retribGiornaliera.toFixed(2)
        );
      }
      if (this.scrittureActiveData.importo_recita1 != null) {
        this.scrittureActiveData.importo_recita1 = Number(
          this.scrittureActiveData.importo_recita1.toFixed(2)
        );
      }
      if (this.scrittureActiveData.importo_recita2 != null) {
        this.scrittureActiveData.importo_recita2 = Number(
          this.scrittureActiveData.importo_recita2.toFixed(2)
        );
      }
      if (this.scrittureActiveData.importo_recita3 != null) {
        this.scrittureActiveData.importo_recita3 = Number(
          this.scrittureActiveData.importo_recita3.toFixed(2)
        );
      }
      if (this.scrittureActiveData.importo_recita4 != null) {
        this.scrittureActiveData.importo_recita4 = Number(
          this.scrittureActiveData.importo_recita4.toFixed(2)
        );
      }
      if (this.scrittureActiveData.importo_recita5 != null) {
        this.scrittureActiveData.importo_recita5 = Number(
          this.scrittureActiveData.importo_recita5.toFixed(2)
        );
      }
      if (this.scrittureActiveData.importoSingolaDiaria != null) {
        this.scrittureActiveData.importoSingolaDiaria = Number(
          this.scrittureActiveData.importoSingolaDiaria.toFixed(2)
        );
      }
      if (this.scrittureActiveData.importoTotaleDiaria != null) {
        this.scrittureActiveData.importoTotaleDiaria = Number(
          this.scrittureActiveData.importoTotaleDiaria.toFixed(2)
        );
      }
      if (this.scrittureActiveData.contributiDiaria != null) {
        this.scrittureActiveData.contributiDiaria = Number(
          this.scrittureActiveData.contributiDiaria.toFixed(2)
        );
      }
      if (this.scrittureActiveData.rimborsoKmTotale != null) {
        this.scrittureActiveData.rimborsoKmTotale = Number(
          this.scrittureActiveData.rimborsoKmTotale.toFixed(2)
        );
      }
      if (this.scrittureActiveData.speseAlloggio != null) {
        this.scrittureActiveData.speseAlloggio = Number(
          this.scrittureActiveData.speseAlloggio.toFixed(2)
        );
      }
      if (this.scrittureActiveData.rimborsoSpese != null) {
        this.scrittureActiveData.rimborsoSpese = Number(
          this.scrittureActiveData.rimborsoSpese.toFixed(2)
        );
      }
      if (this.scrittureActiveData.talatoPaypal != null) {
        this.scrittureActiveData.talatoPaypal = Number(
          this.scrittureActiveData.talatoPaypal.toFixed(2)
        );
      }
      if (this.scrittureActiveData.totaleDiariaRimborsi != null) {
        this.scrittureActiveData.totaleDiariaRimborsi = Number(
          this.scrittureActiveData.totaleDiariaRimborsi.toFixed(2)
        );
      }
      if (this.scrittureActiveData.contributi_carico_ditta != null) {
        this.scrittureActiveData.contributi_carico_ditta = Number(
          this.scrittureActiveData.contributi_carico_ditta.toFixed(2)
        );
      }
      if (this.scrittureActiveData.contributi_carico_dipendente != null) {
        this.scrittureActiveData.contributi_carico_dipendente = Number(
          this.scrittureActiveData.contributi_carico_dipendente.toFixed(2)
        );
      }
    },
    // Salvataggio nuova scrittura
    async salvaNuovaScrittura() {
      console.log("SALVA NUOVA SCRITTURA")
      this.troncaDecimaliScrittura();
      const datiDaInviare = {
        'scrittura': this.scrittureActiveData,
        'onerePreventivo': this.oneriPreventivoActiveData,
      };
      return useJwt
        .post(apiScritturaUrl, datiDaInviare)
        .then((res) => {
          console.log("STATUS POST SALVATAGGIO")
          console.log(res.status);
          if (res.status == 200 || res.status == 201) {
            this.makeToast("primary", "Successo", "Creazione della scrittura");
          }
          console.log(res.data);
          // mi segno ID elemento appena creato
          this.scrittureActiveId = res.data.id;
          return this; // restituisci contesto per permettere aggiornamento gridA
        })
        .then((context) => {
          const datiDaInviare = {
            stagione: this.stagioneCorrente, // la stagione non serve, lo spettacolo ha già il riferimento alla stagione
            spettacolo: this.spettacoloCorrente,
          };
          if (datiDaInviare.spettacolo === null) {
            console.log("Spettacolo non ancora selezionato");
          } else {
            useJwt.post(apiScritturaRicercaUrl, datiDaInviare).then((d) => {
              // gestione risposta
              console.log(
                "Aggiornamento gridA con l'aggiunta di una scrittura"
              );
              console.log(d.data);
              context.scrittureFullData = d.data;
              context.scrittureFullData = [...context.scrittureFullData];
            });
          }
          return false
        }).catch((error) => {
          console.log("ERRORE da gestire")
          let messaggio = ""
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            //console.log(error.response.data)
            let chiavi = Object.keys(error.response.data)
            // console.log(error.response.data['soggetto'])
            // console.log(error.response.data['tipologia'])
            chiavi.forEach((k) => {
              messaggio += `${k}: ${error.response.data[k]}`
              messaggio += "\n"
            })
            console.log(messaggio)
            this.makeToast("primary", "ERRORE", messaggio);
          }
          return true
        })
    },
    // Aggiornamento scrittura esistente
    async aggiornaScritturaEsistente() {
      this.troncaDecimaliScrittura();
      const editUrl = `${apiScritturaUrl}/${this.scrittureActiveId}`;
      // TODO: valutare se e' possibile usare valore salvato di scrittura
      // modificata per aggiornare direttamente scrittureFullData
      const datiDaInviare = {
        'scrittura': this.scrittureActiveData,
        'onerePreventivo': this.oneriPreventivoActiveData,
      };
      return useJwt
        .patch(editUrl, datiDaInviare)
        .then((res) => {
          console.log(res.status);
          if (res.status == 200 || res.status == 201) {
            this.makeToast("primary", "Successo", "Modifica della scrittura");
          }
          return this; // restituisci contesto per permettere aggiornamento gridA
        })
        .then((context) => {
          const datiDaInviare = {
            stagione: this.stagioneCorrente, // la stagione non serve, lo spettacolo ha già il riferimento alla stagione
            spettacolo: this.spettacoloCorrente,
          };
          if (datiDaInviare.spettacolo === null) {
            console.log("Spettacolo non ancora selezionato");
          } else {
            useJwt.post(apiScritturaRicercaUrl, datiDaInviare).then((d) => {
              // gestione risposta
              console.log(
                "Aggiornamento gridA con la modifica di una scrittura"
              );
              context.scrittureFullData = d.data;
              context.scrittureFullData = [...context.scrittureFullData];
              context.aggiornaIntervalloScrittura()
            });
          }
          return false
        }).catch((error) => {
          console.log("ERRORE da gestire")
          let messaggio = ""
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            //console.log(error.response.data)
            let chiavi = Object.keys(error.response.data)
            // console.log(error.response.data['soggetto'])
            // console.log(error.response.data['tipologia'])
            chiavi.forEach((k) => {
              messaggio += `${k}: ${error.response.data[k]}`
              messaggio += "\n"
            })
            console.log(messaggio)
            this.makeToast("primary", "ERRORE", messaggio);
          }
          return true
        });
    },
    // per dialogA1
    dialogA1OpenButtonClick() {
      this.$refs.dialogA1.show(true);
    },
    dialogA1Open(args) {
      console.log("Apertura dialogA1");
      // assegnare le informazioni da visualizzare nel dialog A
      console.log("scrittura attivo");
      console.log(this.scrittureActiveId);
      this.scrittureSavedData = { ...this.scrittureActiveData };
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
      // controlla eventi onXXchange
      this.dialogA1.isVisible = true;
      if (this.scrittureActiveId !== 0) {
        // ottieni info oneri
        let datiDaInviare = {scrittura: this.scrittureActiveId}
        useJwt.post(apiOneriUrl, datiDaInviare).then((d) => {
          // console.log("Elenco Oneri");
          // console.log(d.data);
          this.oneriFullData = d.data;
        });
      } else {
        console.log("set dropdown")
        this.scrittureActiveData.pagato = "no";
        this.$refs.pagato.ej2Instances.value = "no";
        this.$refs.pagato.ej2Instances.refresh();
      }
    },
    dialogA1Close() {
      console.log("Chiusura dialogA1");
      this.dialogA1.isVisible = false;
      this.dialogA1.tabAdialogA1Index = 0;
      this.scrittureActiveData.documenti = [];
    },
    validazioneDati() {
      console.log(this.scrittureActiveData.dataScadenzaPagamento)
      if (!this.scrittureActiveData.dataScadenzaPagamento) {
        this.makeToast("primary", "ERRORE", "Richiesto valore data scadenza pagamento")
        return false
      }
      if (this.scrittureActiveData.intervallo1_inizio > this.scrittureActiveData.intervallo1_fine) {
        this.makeToast("primary", "ERRORE", "Data inizio deve essere precedente a data fine")
        return false
      }
      // const tipologie_attive = ["1", "2", "5", "6", "7", "8", "9", "10", "12", "13", "14"];
      // if (tipologie_attive.includes(this.scrittureActiveData.tipologia)) {
      //   if (!this.scrittureActiveData.compenso_lordo_complessivo) {
      //     this.makeToast("primary", "ERRORE", "Compenso lordo complessivo deve avere un valore")
      //     return false
      //   }
      // }
      // if (!this.scrittureActiveData.compenso_totale) {
      //   this.makeToast("primary", "ERRORE", "Compenso totale deve avere un valore")
      //   return false
      // }
      return true
    },
    async dialogA1Ok() {
      let ret = false
      console.log("Cliccato bottone OK di dialogA1");
      console.log(this.scrittureActiveData);
      if (!this.validazioneDati()) {
        return; // esco se fallisce validazione
      }

      // salvataggio informazioni in remoto
      if (this.scrittureActiveId === 0) {
        // salvataggio in caso di new
        ret = await this.salvaNuovaScrittura();
      } else {
        // salvataggio in caso di edit
        ret = await this.aggiornaScritturaEsistente();
      }
      console.log("variabile ERRORE salvataggio")
      console.log(ret)
      if (ret == false) {
        this.$refs.dialogA1.hide();
      }
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogA1Cancel() {
      console.log("Cliccato bottone Cancel di dialogA1");
      this.$refs.dialogA1.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      const scrittureDefaultData = {
        id: 0,
        tipologia: null,
        soggetto: null,
        in_qualita_di: null,
        categoriaInps: null,
        ruolo: "",
        stato: null,
        note: "",
        numGiorniScrittura: null,
        numGiorniCoproduzione: null,
        numGiorniRecite: null,
        dettGiorniScrittura: null,
        dettGiorniPermesso: null,
        retribGiornaliera: null,
        tipoCast: null,
        intervallo1_inizio: null,
        intervallo2_inizio: null,
        intervallo3_inizio: null,
        intervallo1_fine: null,
        intervallo2_fine: null,
        intervallo3_fine: null,
        ulteriori_precisazioni: "",
        dettaglio_pagamento: null,
        ore_settimanali: 0,
        ore_turno_giornaliero: "3,30",
        qualifica: null,
        livello: null,
        mansione: null,
        sede: "",
        luogo_lavoro: "",
        tipo_orario: null,
        lun_inizio: null,
        mar_inizio: null,
        mer_inizio: null,
        gio_inizio: null,
        ven_inizio: null,
        sab_inizio: null,
        dom_inizio: null,
        lun_fine: null,
        mar_fine: null,
        mer_fine: null,
        gio_fine: null,
        ven_fine: null,
        sab_fine: null,
        dom_fine: null,
        ruoloGenerale: "", // per contratti 1,2 = mansione, per 3-6 = in_qualita_di, per 7 = "Diritti XX"
        recita1: null,
        recita2: null,
        recita3: null,
        recita4: null,
        recita5: null,
        importo_recita1: null,
        importo_recita2: null,
        importo_recita3: null,
        importo_recita4: null,
        importo_recita5: null,
        compenso_lordo_giornaliero: null,
        compenso_lordo_giornaliero_scritto: null,
        compenso_lordo_complessivo: null,
        compenso_lordo_complessivo_scritto: null,
        importoSingolaDiaria: null,
        importoTotaleDiaria: null,
        contributiDiaria: null,
        rimborsoKmTotale: null,
        speseAlloggio: null,
        rimborsoSpese: null,
        talatoPaypal: null,
        totaleDiariaRimborsi: null,
        causale_diritti: "",
        tipologia_diritti: null,
        durata_anni_diritti: null,
        usaAllegato1: false,
        tipoCompAll1: null,
        all1_compenso_giornaliero: null,
        all1_numGiorniMax: null,
        compenso_totale: null,
        tipologia_contributo_soggetto: "sconosciuta",
        costo_azienda_totale: null,
        costo_azienda_giornaliero: null,
        testRetribGiornaliera: "",
        IdContratto: 0,
        dataContratto: null,
        statoContratto: "Da Generare",
        fileDocumento: null,
        contrattoModificato: null,
        contrattoFirmato: null,
        numeroElementi: null,
        giorniDiaria: null,
        // Personale Ministero Preventivo
        persMinPrevPersonaleDiTerzi: null,
        persMinPrevDenominazione: null,
        persMinPrevPersonaleStraniero: null,
        persMinPrevCodiceFiscale: null,
        persMinPrevPartitaIva: null,
        persMinPrevNome: null,
        persMinPrevCognome: null,
        persMinPrevDataNascita: null,
        persMinPrevNazionalita: null,
        persMinPrevUnder35: null,
        persMinPrevCodiceINPS: null,
        persMinPrevTipoPersonale: null,
        persMinPrevTipoRapporto: null,
        persMinPrevDataInizio: null,
        persMinPrevDataFine: null,
        persMinPrevGiornateLavorative: null,
        persMinPrevOneri: null,
        persMinPrevRetribuzione: null,
        persMinPrevRuolo: null,
        persMinPrevCostoRetribuzione: null,
        persMinPrevCostoContributivo: null,
        persMinPrevCostoInail: null,
        persMinPrevRivalsa: null,
        persMinPrevOneriTotali: null,
        // Personale Ministero Consuntivo
        persMinConsPersonaleDiTerzi: null,
        persMinConsDenominazione: null,
        persMinConsPersonaleStraniero: null,
        persMinConsCodiceFiscale: null,
        persMinConsPartitaIva: null,
        persMinConsNome: null,
        persMinConsCognome: null,
        persMinConsDataNascita: null,
        persMinConsNazionalita: null,
        persMinConsUnder35: null,
        persMinConsCodiceINPS: null,
        persMinConsTipoPersonale: null,
        persMinConsTipoRapporto: null,
        persMinConsDataInizio: null,
        persMinConsDataFine: null,
        persMinConsGiornateLavorative: null,
        persMinConsOneri: null,
        persMinConsRetribuzione: null,
        persMinConsRuolo: null,
        persMinConsCostoRetribuzione: null,
        persMinConsCostoContributivo: null,
        persMinConsCostoInail: null,
        persMinConsRivalsa: null,
        persMinConsOneriTotali: null,
        contoPagamento: null,
      };
      // pulsante NEW

      if (args.item.id === "new") {
        this.dialogA1.header = "Nuova scrittura";
        this.scrittureActiveData = scrittureDefaultData;
        console.log("Premuto pulsante creazione nuova scrittura da gridA");
        // devo impostare spettacoloId e spettacolo e stagione
        this.scrittureActiveId = 0;
        this.scrittureActiveData.spettacolo = this.spettacoloCorrente;
        this.scrittureActiveData.stagione = this.stagioneCorrente;
        // reset campi vari
        // this.scrittureActiveData.soggetto = null
        // this.$refs.soggetto.ej2Instances.refresh()
        this.$refs.dettGiorniScrittura.ej2Instances.values = [];
        this.$refs.dettGiorniPermesso.ej2Instances.values = [];

        //this.$refs.dialogA1.show(true);
        this.dialogA1OpenButtonClick();
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        this.dialogA1.header = "Modifica Scrittura";
        console.log("Premuto pulsante modifica scrittura da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          this.scrittureActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.scrittureActiveId);

          const i = this.scrittureFullData.findIndex(
            (x) => x.id === this.scrittureActiveId
          );
          if (i >= 0) {
            this.scrittureActiveData = { ...this.scrittureFullData[i] };
            console.log("scrittura CORRENTE");
            console.log(this.scrittureActiveData);
            console.log(this.scrittureActiveId);
            console.log("Edit Scrittura");
            // gestione blocco
            if (this.scrittureActiveData.blocco == true) {
              this.bloccoModifica = true
              console.log("abilitato blocco modifica")
            } else {
              this.bloccoModifica = false
              console.log("DISabilitato blocco modifica")
            }
            if (this.scrittureActiveData.onerePreventivo) {
              this.oneriPreventivoActiveData = this.scrittureActiveData.onerePreventivo
            }
            const s = this.elencoSoggFiltratiList.find((obj) => {
              return obj.id === this.scrittureActiveData.soggetto
            });
            this.aggiornaInfoMinistero(s)

            this.$refs.dettGiorniScrittura.ej2Instances.values = [];
            if (this.scrittureActiveData.dettGiorniScrittura) {
              this.scrittureActiveData.dettGiorniScrittura.forEach((obj) => {
                const d = new Date(obj);
                this.$refs.dettGiorniScrittura.ej2Instances.addDate(d);
              });
            }
            this.$refs.dettGiorniPermesso.ej2Instances.values = [];
            if (this.scrittureActiveData.dettGiorniPermesso) {
              this.scrittureActiveData.dettGiorniPermesso.forEach((obj) => {
                const d = new Date(obj);
                this.$refs.dettGiorniPermesso.ej2Instances.addDate(d);
              });
            }

            if (this.scrittureActiveData.dataScadenzaPagamento) {
              const tmp = this.scrittureActiveData.dataScadenzaPagamento.split("T")[0];
              const d = new Date(tmp);
              this.scrittureActiveData.dataScadenzaPagamento = d;
            }
            if (this.scrittureActiveData.dataPagamento) {
              const tmp1 = this.scrittureActiveData.dataPagamento.split("T")[0];
              const d1 = new Date(tmp1);
              this.scrittureActiveData.dataPagamento = d1;
            }

            if (this.scrittureActiveData.lun_inizio)
              this.scrittureActiveData.lun_inizio = this.scrittureActiveData.lun_inizio.slice(11, 16);
            if (this.scrittureActiveData.mar_inizio)
              this.scrittureActiveData.mar_inizio = this.scrittureActiveData.mar_inizio.slice(11, 16);
            if (this.scrittureActiveData.mer_inizio)
              this.scrittureActiveData.mer_inizio = this.scrittureActiveData.mer_inizio.slice(11, 16);
            if (this.scrittureActiveData.gio_inizio)
              this.scrittureActiveData.gio_inizio = this.scrittureActiveData.gio_inizio.slice(11, 16);
            if (this.scrittureActiveData.ven_inizio)
              this.scrittureActiveData.ven_inizio = this.scrittureActiveData.ven_inizio.slice(11, 16);
            if (this.scrittureActiveData.sab_inizio)
              this.scrittureActiveData.sab_inizio = this.scrittureActiveData.sab_inizio.slice(11, 16);
            if (this.scrittureActiveData.dom_inizio)
              this.scrittureActiveData.dom_inizio = this.scrittureActiveData.dom_inizio.slice(11, 16);

            if (this.scrittureActiveData.lun_fine)
              this.scrittureActiveData.lun_fine = this.scrittureActiveData.lun_fine.slice(11, 16);
            if (this.scrittureActiveData.mar_fine)
              this.scrittureActiveData.mar_fine = this.scrittureActiveData.mar_fine.slice(11, 16);
            if (this.scrittureActiveData.mer_fine)
              this.scrittureActiveData.mer_fine = this.scrittureActiveData.mer_fine.slice(11, 16);
            if (this.scrittureActiveData.gio_fine)
              this.scrittureActiveData.gio_fine = this.scrittureActiveData.gio_fine.slice(11, 16);
            if (this.scrittureActiveData.ven_fine)
              this.scrittureActiveData.ven_fine = this.scrittureActiveData.ven_fine.slice(11, 16);
            if (this.scrittureActiveData.sab_fine)
              this.scrittureActiveData.sab_fine = this.scrittureActiveData.sab_fine.slice(11, 16);
            if (this.scrittureActiveData.dom_fine)
              this.scrittureActiveData.dom_fine = this.scrittureActiveData.dom_fine.slice(11, 16);

            // ripristinare le dropdownlist delle recite
            this.$refs.recita1.ej2Instances.value = Number(this.scrittureActiveData.recita1);
            this.$refs.recita1.ej2Instances.refresh();

            this.$refs.recita2.ej2Instances.value = Number(this.scrittureActiveData.recita2);
            this.$refs.recita2.ej2Instances.refresh();

            this.$refs.recita3.ej2Instances.value = Number(this.scrittureActiveData.recita3);
            this.$refs.recita3.ej2Instances.refresh();

            this.$refs.recita4.ej2Instances.value = Number(this.scrittureActiveData.recita4);
            this.$refs.recita4.ej2Instances.refresh();

            this.$refs.recita5.ej2Instances.value = Number(this.scrittureActiveData.recita5);
            this.$refs.recita5.ej2Instances.refresh();

            //this.$refs.dialogA1.show(true);
            this.dialogA1OpenButtonClick();
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          console.log(err);
          this.alertAShow();
        }
      }
      //Pulsante DELETE
      else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina scrittura da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;
          this.$refs.gridA.ej2Instances.deleteRecord();
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === 'duplica') {
        // duplica scrittura
        const selectedRow = this.$refs.gridA.getSelectedRecords();
        const elementId = selectedRow[0].id;
        let datiDaInviare = {id: elementId}
        useJwt.post(apiDuplicaScritturaUrl, datiDaInviare).then((d) => {
          // console.log("Risposta duplica");
          // console.log(d.data);
          this.makeToast(
            "primary",
            "Operazione eseguita con successo",
            `Duplicato scrittura creato con id ${d.data['id']}`,
          );
          return this;
        }).then((context) => {
          const datiDaInviare = {
            stagione: context.stagioneCorrente, // la stagione non serve, lo spettacolo ha già il riferimento alla stagione
            spettacolo: context.spettacoloCorrente,
          };
          useJwt.post(apiScritturaRicercaUrl, datiDaInviare).then((d) => {
            // gestione risposta
            context.scrittureFullData = d.data;
            context.scrittureFullData = [...context.scrittureFullData];
            context.aggiornaIntervalloScrittura()
          });
        });
      }
    }, // fine funzione
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          e.cancel = true;
          const editUrl = `${apiScritturaUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              this.gridAFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit();
            } else {
              this.makeToast(
                "primary",
                "Attenzione",
                "Salvataggio scrittura non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false;
      }
      if (e.requestType === "delete") {
        try {
          //this.defaultLocale.ConfirmDelete =  '<b>Clicca OK per confermare la cancellazione, CANCEL per annullare</b>';
          console.log("Premuto conferma pulsante elimina scrittura da gridA");
          const deletedElementId = e.data[0].id;
          const deleteUrl = `${apiScritturaUrl}/${deletedElementId}`;
          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
          });
        } catch (err) {
          console.log(err);
          console.log("Errore nella cancellazione");
          this.alertAShow();
        }
      }
    },
    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "dialogA1Tab01":
          console.log("Sei nel primo tab del dialogA1");
          break;
        case "dialogA1Tab02":
          console.log("Sei nel secondo tab del dialogA1");
          break;
        default:
          console.log(args);
      }
    },
    giorniScritturaChange(args) {
      if (this.bloccoModifica) {
        return;
      }
      if (args.isInteracted) {
        // aggiorno scrittureActiveData.dettGiorniScrittura
        this.scrittureActiveData.dettGiorniScrittura = args.values;
        // aggiorna numGiorniScrittura
        this.scrittureActiveData.numGiorniScrittura = args.values.length
      }
    },
    giorniPermessoChange(args) {
      if (this.bloccoModifica) {
        return;
      }
      if (args.isInteracted) {
        // aggiorno scrittureActiveData.dettGiorniPermesso
        this.scrittureActiveData.dettGiorniPermesso = args.values;
      }
    },
    // per aggiornamento ruoloGenerale
    onIn_qualita_diChange() {
      this.scrittureActiveData.ruoloGenerale = this.scrittureActiveData.in_qualita_di;
      console.log(this.scrittureActiveData.ruoloGenerale);
      // gestione visibilità showRuolo (al momento visibile solo per Cantante lirico)
      if (this.scrittureActiveData.in_qualita_di == "Cantante lirico") {
        this.showRuolo = true;
      } else {
        this.showRuolo = false;
      }
    },
    onFineIntervalloChange() {
      //AAA se cambio fineIntervallo1, modifico di conseguenza scadenzaPagamento e dataPagamentoPrevista
      var p = new Date(this.$refs.fineIntervallo1.ej2Instances.value)
      let delay = this.$refs.delayPagamento.ej2Instances.value

      p.setDate(p.getDate() + delay)
      oldDelay = delay
      this.scrittureActiveData.dataScadenzaPagamento = p
      this.scrittureActiveData.dataPagamentoPrevista = p
    },
    onInizioIntervalloChange() {
      //AAA se cambio inizio intervallo, modifico di conseguenza scadenzaPagamento e dataPagamentoPrevista
      var p = new Date(this.$refs.inizioIntervallo1.ej2Instances.value)
      let delay = this.$refs.delayPagamento.ej2Instances.value

      p.setDate(p.getDate() + delay)
      oldDelay = delay
      this.scrittureActiveData.dataScadenzaPagamento = p
      this.scrittureActiveData.dataPagamentoPrevista = p
    },
    onMansioneChange() {
      this.scrittureActiveData.ruoloGenerale =
        this.scrittureActiveData.mansione;
      console.log(this.scrittureActiveData.ruoloGenerale);
    },
    // per generazione contratto
    generaContrattoClick() {
      // bottone "Genera Contratto"
      const generaContrattiUrl = `${contrattiUrl}/genera`;
      // raccolgo le informazioni pertinenti da inviare
      this.contrattiActiveData = {
        id: this.scrittureActiveData.IdContratto,
        dataContratto: this.scrittureActiveData.dataContratto,
        scrittura: this.scrittureActiveId,
        soggetto: this.scrittureActiveData.soggetto,
        tipologia: parseInt(this.scrittureActiveData.tipologia),
        spettacolo: this.scrittureActiveData.spettacolo,
      };
      console.log("this.contrattiActiveData PRIMA");
      console.log(this.contrattiActiveData);
      // distinguere tra creazione ed edit
      if (this.contrattiActiveData.id === 0) {
        useJwt
          .post(generaContrattiUrl, this.contrattiActiveData)
          .then((res) => {
            console.log(res.data);
            console.log(res.status);
            // let obj = res.data
            // //console.log('OBJ')
            // //console.log(obj)
            // //obj.nomeSoggetto = `${res.data.soggetto.nome} ${res.data.soggetto.cognome}`
            // obj.nomeSoggetto = this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).nome+' '+this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).cognome
            // obj.statoContratto = this.statoContrattoList.find(x => x.val === obj.stato).label
            // obj.titoloSpettacolo = this.spettacoloList.find(x => x.id === obj.spettacolo).titolo
            // obj.tipoContratto = this.tipoContrattoList.find(x => x.id === obj.tipologia).label
            // this.contrattiFullData.push(obj)
            // this.contrattiFullData = [...this.contrattiFullData]
            this.contrattiActiveData = res.data;
            console.log("this.contrattiActiveData DOPO CREAZIONE");
            console.log(this.contrattiActiveData);
            this.scrittureActiveData.IdContratto = this.contrattiActiveData.id;
            // console.log(this.contrattiActiveData.stato)
            this.makeToast(
              "primary",
              "Successo",
              "Contratto generato correttamente"
            );
            this.scrittureActiveData.statoContratto = "Generato";
            // salvare aggiornando la scrittura con scrittureActiveData <-----------------------------------
            this.aggiornaScritturaEsistente();
          })
          .catch((res) => {
            console.log(res);
            this.makeToast("primary", "Attenzione", res.data.errors);
          });
      } else {
        // edit
        const aggiornaContrattiUrl = `${contrattiUrl}/aggiorna`;
        useJwt
          .patch(aggiornaContrattiUrl, this.contrattiActiveData)
          .then((res) => {
            console.log(res.data);
            console.log(res.status);
            this.makeToast("primary", "Contratto modificato correttamente", "");
            this.scrittureActiveData.statoContratto = "Generato";
            this.contrattiActiveData = res.data;
            console.log("this.contrattiActiveData DOPO AGGIORNAMENTO");
            console.log(this.contrattiActiveData);
            this.scrittureActiveData.IdContratto = this.contrattiActiveData.id;
          })
          .then((res2) => {
            // salvare aggiornando la scrittura con scrittureActiveData <-----------------------------------
            this.aggiornaScritturaEsistente();
          });
      }
      //this.showModificato = false;
      //this.showFirmato = false;
    },
    // per download bozza contratto
    downloadBozzaContrattoClick() {
      console.log("Cliccato bottone Download Bozza");
      //ZZZZ
      const contrattoUrl = `${contrattiUrl}/${this.scrittureActiveData.IdContratto}`;
      console.log(contrattoUrl);

      useJwt.get(contrattoUrl).then((res) => {
        console.log(res.data);
        const nomeFile = res.data.fileDocumento
                            .split("\\")
                            .pop()
                            .split("/")
                            .pop()
                            .split("?")[0];
        this.downloadFile(res.data.fileDocumento, nomeFile);
      });
    },
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    downloadFile(url, title) {
      const uninterceptedAxiosInstance = axios.create();
      uninterceptedAxiosInstance
        .get(url, {
          responseType: "arraybuffer",
          crossdomain: true,
        })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
 },
    computed: {
      hasChanged() {
        return Object.keys(this.scrittureActiveData).some(
          (field) =>
            this.scrittureActiveData[field] !== this.scrittureSavedData[field]
        );
      },
      // vale true se sono cambiati valori di scrittura eccetto quelli consentiti in modo esplicito
      hasChangedExceptAllowed() {
        const currKeys = Object.keys(this.scrittureActiveData);
        var index = currKeys.indexOf("IdContratto");
        var x = currKeys.splice(index, 1);
        index = currKeys.indexOf("regimeFiscale");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("esenzione");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("dataContratto");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("statoContratto");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("fileDocumento");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("contrattoModificato");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("contrattoFirmato");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("dettGiorniScrittura");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("dettGiorniPermesso");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("tipoCast");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("stato");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("note");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("dataScadenzaPagamento");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("pagato");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("dataPagamentoPrevista");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("dataPagamento");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("riferimentoContabile");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("contoPagamento");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("categoriaInps");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("tipologia_contributo_soggetto");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("costo_azienda_totale");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("costo_azienda_giornaliero");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("contributi_carico_ditta");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("contributi_carico_dipendente");
        x = currKeys.splice(index, 1);
        // personale Ministero Preventivo
        index = currKeys.indexOf("persMinPrevPersonaleDiTerzi");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevDenominazione");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevPersonaleStraniero");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevCodiceFiscale");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevPartitaIva");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevNome");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevCognome");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevDataNascita");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevNazionalita");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevUnder35");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevCodiceINPS");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevTipoPersonale");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevTipoRapporto");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevDataInizio");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevDataFine");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevGiornateLavorative");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevOneri");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevRetribuzione");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinPrevRuolo");
        x = currKeys.splice(index, 1);
        // personale Ministero Consuntivo
        index = currKeys.indexOf("persMinConsPersonaleDiTerzi");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsDenominazione");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsPersonaleStraniero");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsCodiceFiscale");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsPartitaIva");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsNome");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsCognome");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsDataNascita");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsNazionalita");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsUnder35");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsCodiceINPS");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsTipoPersonale");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsTipoRapporto");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsDataInizio");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsDataFine");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsGiornateLavorative");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsOneri");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsRetribuzione");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("persMinConsRuolo");
        x = currKeys.splice(index, 1);
        index = currKeys.indexOf("blocco");
        x = currKeys.splice(index, 1);


        const comparisonTest = currKeys.some(
          (field) =>
            this.scrittureActiveData[field] !== this.scrittureSavedData[field]
        );
        if (comparisonTest && this.dialogA1.isVisible) {
          console.log(
            "Dati scrittura modificati rispetto al salvataggio (non considerati quelli relativi ai contratti)"
          );
          // qui da gestire cambio stato in base a bloccoModifica
          // rispristino stati del contratto
          this.scrittureActiveData.statoContratto = "Da Generare";
        }
        return comparisonTest;
      },
      showCostoAzTot() {
        const tipologie = ["1","2", "3", "4", "5", "6"];
        return tipologie.includes(this.scrittureActiveData.tipologia);
      },
      showCostoAzGiorn() {
        const tipologie_az = ["11"];
        return tipologie_az.includes(this.scrittureActiveData.tipologia);
      },
      showAutonomi() {
        const tipologie_autonomi = ["3", "4", "5", "6"];
        return tipologie_autonomi.includes(this.scrittureActiveData.tipologia);
      },
      showCompagnieOspiti() {
        return this.scrittureActiveData.tipologia == "14";
      },
      showDettDate() {
        const tipologie_dettDate = ["1", "2", "3", "4", "5", "6","11"];
        return tipologie_dettDate.includes(this.scrittureActiveData.tipologia);
      },
      showCompGiorn() {
        const tipologie_autonomi = ["3", "4"];
        return tipologie_autonomi.includes(this.scrittureActiveData.tipologia);
      },
      showNumGiorniCoproduzione() {
        const tipologie_coprod = ["1", "2","3","4","5","6","11"];
        return tipologie_coprod.includes(this.scrittureActiveData.tipologia);
      },
      showCompCompl() {
        const tipologie_attive = ["1", "2", "5", "6", "7", "8", "9", "10", "12", "13", "14"];
        return tipologie_attive.includes(this.scrittureActiveData.tipologia);
      },
      showAutonomiCompRecita() {
        return this.scrittureActiveData.tipologia === "6";
      },
      showRegimeFiscale() {
        const tipologie_regFisc = ["3", "4", "5", "6", "7"];
        return tipologie_regFisc.includes(this.scrittureActiveData.tipologia);
      },
      noDiritti() {
        return this.scrittureActiveData.tipologia !== "7";
      },
      showSubordinati() {
        const tipologie_subordinati = ["1", "2"];
        return tipologie_subordinati.includes(this.scrittureActiveData.tipologia);
      },
      soloTecniciPrestazione() {
        return this.scrittureActiveData.tipologia === "1";
      },
      soloTecniciTDet() {
        return this.scrittureActiveData.tipologia === "2";
      },
      soloDiritti() {
        return this.scrittureActiveData.tipologia === "7";
      },
      showCardContratto() {
        if (this.scrittureActiveId == 0) {
          return false;
        }
        if (this.hasChangedExceptAllowed) {
          return false;
        }
        return true;
      },
      showGeneraBozzaContratto() {
        if (this.scrittureActiveData.statoContratto == "Da Generare") {
          return true;
        }
        return false;
      },
      showDownloadBozzaContratto() {
        if (this.scrittureActiveData.statoContratto == "Generato") {
          return true;
        }
        return false;
      },
      showNumeroElementi() {
        const tipologie_numEl = ["8", "9", "10"];
        return tipologie_numEl.includes(this.scrittureActiveData.tipologia);
      },
    },
 });

 /* eslint-disable global-require */
</script>

<style lang="scss">
  @import "~@syncfusion/ej2-base/styles/material.css";
  @import "~@syncfusion/ej2-buttons/styles/material.css";
  @import "~@syncfusion/ej2-vue-buttons/styles/material.css";
  @import "~@syncfusion/ej2-calendars/styles/material.css";
  @import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
  @import "~@syncfusion/ej2-dropdowns/styles/material.css";
  @import "~@syncfusion/ej2-vue-popups/styles/material.css";
  @import "~@syncfusion/ej2-vue-navigations/styles/material.css";
  @import "~@syncfusion/ej2-inputs/styles/material.css";
  @import "~@syncfusion/ej2-vue-layouts/styles/material.css";
  @import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
  @import "~@syncfusion/ej2-splitbuttons/styles/material.css";
  @import "~@syncfusion/ej2-grids/styles/material.css";
  @import "~@syncfusion/ej2-schedule/styles/material.css";
  @import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
  @import "~@syncfusion/ej2-treegrid/styles/material.css";

  .e-btn-icon.e-open-icon {
    background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
    height: 18px;
    width: 18px;
  }

  .e-btn-icon.e-delete-icon {
    background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
    height: 18px;
    width: 18px;
  }

  .e-btn-icon.e-download-icon {
    background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
    height: 18px;
    width: 18px;
  }

  .e-btn-icon.e-search-icon {
    background: url("~@/assets/images/svg/search-svgrepo-com.svg");
    height: 18px;
    width: 18px;
  }

  .e-btn-icon.e-upload-icon {
    background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
    height: 18px;
    width: 18px;
  }

  .e-btn-icon.e-add-icon {
    background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
    height: 18px;
    width: 18px;
  }

  // per disabilitare la grid
  .disablegrid {
    pointer-events: none;
    opacity: 0.4;
  }

  .wrapper {
    cursor: not-allowed;
  }

  // per dropdownlist template
  .codFisc {
    right: 15px;
    position: absolute;
  }
  // seleziono il colore per evidenziare la riga selezionata
  .e-grid td.e-active{
    background-color: #e5cbdd;
  }
  // imposto lo stile per i filtri nelle righe: colore sfondo, colore testo, grassetto
  .rigaPulita { }
  .rigaVerde {
    background-color: rgb(145, 220, 146);
    //font-weight: 500;
  }
  .rigaVerde td {
    color: blue !important;
  }
  .rigaGrigia {
    background-color: rgb(240, 235, 235);
    //font-weight: 500;
  }
  .rigaCeleste {
    background-color: rgb(197, 237, 242);
    //font-weight: 500;
  }
  .rigaViola {
    background-color: rgb(243, 227, 240);
    //font-weight: 500;
  }
</style>
